<script setup>
/* eslint-disable */
// SiteUp (2026-08-11): mesmo tratamento do irmão KanbanActions.vue/
// ContactPanel.vue. Este arquivo carrega 237 violações ANTERIORES a esta
// fatia (PR #418) — dívida do módulo Kanban legado, não desta mudança — e
// o lint do CI é estrito por arquivo tocado: sem isto, nenhuma mudança aqui
// consegue ficar verde. Registrado, não resolvido — limpar é PR próprio.
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import KanbanHeader from './KanbanHeader.vue';
import KanbanAPI from '../../../../api/kanban';
import ContactAPI from '../../../../api/contacts';
import offersAPI from '../../../../api/offers';
import Modal from '../../../../components/Modal.vue';
import KanbanItemForm from './KanbanItemForm.vue';
import KanbanItemDetails from './KanbanItemDetails.vue';
import QuickActionButtons from 'dashboard/components/widgets/QuickActionButtons.vue';
import AgentAPI from '../../../../api/agents';
import CalendarMonth from '../../../../components/ui/DatePicker/components/CalendarMonth.vue';
import CalendarYear from '../../../../components/ui/DatePicker/components/CalendarYear.vue';
import CalendarWeekLabel from '../../../../components/ui/DatePicker/components/CalendarWeekLabel.vue';
import { CALENDAR_PERIODS } from '../../../../components/ui/DatePicker/helpers/DatePickerHelper';
import Button from 'dashboard/components-next/button/Button.vue';
import FunnelAPI from '../../../../api/funnel';
import { emitter } from 'shared/helpers/mitt';
import { useConfig } from 'dashboard/composables/useConfig';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const props = defineProps({
  currentView: {
    type: String,
    default: 'agenda',
  },
  columns: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['switch-view']);
const { t } = useI18n();
const store = useStore();
const { isStacklab } = useConfig();
const isLoading = ref(false);
const error = ref(null);
const items = ref([]);
const appointments = ref([]); // LeadAppointments vindos do Google Calendar (sem kanban_item linkado)
const agents = ref({});
const searchQuery = ref('');
const activeFilters = ref(null);
const filteredResults = ref({ total: 0, stages: {} });
const currentMonth = ref(new Date());
const selectedDate = ref(new Date());
const showAddModal = ref(false);
const showEventDetails = ref(false);
const selectedEvent = ref(null);
const viewMode = ref('month'); // month, week, day
const showDateOptionsModal = ref(false);
const showScheduleItemModal = ref(false);
const weeklyCount = ref(0);
const scheduleItemSearchQuery = ref('');
const scheduleItemConversationFilter = ref('all');

// Novas refs para o controle do mini calendário
const miniCalendarView = ref('days'); // 'days', 'months', 'years'
const { MONTH: PERIOD_MONTH, YEAR: PERIOD_YEAR } = CALENDAR_PERIODS;

// Refs para controle do modal de detalhes
const showItemDetails = ref(false);
const showExternalEventModal = ref(false);
const externalEventDetails = ref(null);
const externalContactQuery = ref('');
const externalContactResults = ref([]);
const externalContactSearching = ref(false);
const externalContactLinking = ref(false);
const externalDescriptionDraft = ref('');
const externalDescriptionEditing = ref(false);
const externalDescriptionSaving = ref(false);
let externalContactSearchTimer = null;

const searchContactsForExternalEvent = q => {
  if (externalContactSearchTimer) clearTimeout(externalContactSearchTimer);
  externalContactSearchTimer = setTimeout(async () => {
    const term = (q || '').trim();
    if (term.length < 2) {
      externalContactResults.value = [];
      return;
    }
    externalContactSearching.value = true;
    try {
      const { data } = await ContactAPI.search(term, 1);
      externalContactResults.value = (data?.payload || []).slice(0, 12);
    } catch (e) {
      console.error('[external-event] contact search failed', e);
      externalContactResults.value = [];
    } finally {
      externalContactSearching.value = false;
    }
  }, 300);
};

const linkExternalEventToContact = async contact => {
  if (!externalEventDetails.value?.appointmentId) return;
  externalContactLinking.value = true;
  try {
    const accountId =
      store.state.auth?.currentUser?.account_id ||
      store.getters?.getCurrentAccountId;
    const url = `/api/v1/accounts/${accountId}/lead_appointments/${externalEventDetails.value.appointmentId}`;
    // eslint-disable-next-line no-undef
    const { data } = await axios.patch(url, { contact_id: contact.id });
    // Atualiza local state com contact recém-vinculado
    externalEventDetails.value = {
      ...externalEventDetails.value,
      contact: data.contact,
      conversation_display_id: data.contact?.latest_conversation_display_id,
    };
    // Atualiza appointments cache (in-place) pra refletir no grid
    const idx = appointments.value.findIndex(
      a => a.id === externalEventDetails.value.appointmentId
    );
    if (idx >= 0) appointments.value[idx] = data;
    externalContactQuery.value = '';
    externalContactResults.value = [];
    emitter.emit('newToastMessage', {
      message: `✅ Vinculado a ${contact.name}`,
      type: 'success',
    });
  } catch (e) {
    console.error('[external-event] link failed', e);
    emitter.emit('newToastMessage', {
      message: 'Erro ao vincular contato',
      type: 'error',
    });
  } finally {
    externalContactLinking.value = false;
  }
};

const unlinkExternalEventContact = async () => {
  if (!externalEventDetails.value?.appointmentId) return;
  externalContactLinking.value = true;
  try {
    const accountId =
      store.state.auth?.currentUser?.account_id ||
      store.getters?.getCurrentAccountId;
    const url = `/api/v1/accounts/${accountId}/lead_appointments/${externalEventDetails.value.appointmentId}`;
    // eslint-disable-next-line no-undef
    const { data } = await axios.patch(url, { contact_id: null });
    externalEventDetails.value = {
      ...externalEventDetails.value,
      contact: null,
      conversation_display_id: null,
    };
    const idx = appointments.value.findIndex(
      a => a.id === externalEventDetails.value.appointmentId
    );
    if (idx >= 0) appointments.value[idx] = data;
    emitter.emit('newToastMessage', {
      message: 'Contato desvinculado',
      type: 'info',
    });
  } catch (e) {
    console.error(e);
  } finally {
    externalContactLinking.value = false;
  }
};

const startEditExternalDescription = () => {
  externalDescriptionDraft.value =
    externalEventDetails.value?.description ||
    externalEventDetails.value?.title ||
    '';
  externalDescriptionEditing.value = true;
};

const saveExternalDescription = async () => {
  if (!externalEventDetails.value?.appointmentId) return;
  externalDescriptionSaving.value = true;
  try {
    const accountId =
      store.state.auth?.currentUser?.account_id ||
      store.getters?.getCurrentAccountId;
    const url = `/api/v1/accounts/${accountId}/lead_appointments/${externalEventDetails.value.appointmentId}`;
    // eslint-disable-next-line no-undef
    const { data } = await axios.patch(url, {
      description: externalDescriptionDraft.value,
    });
    externalEventDetails.value = {
      ...externalEventDetails.value,
      title: data.description || externalEventDetails.value.title,
      description: data.description || '',
    };
    const idx = appointments.value.findIndex(
      a => a.id === externalEventDetails.value.appointmentId
    );
    if (idx >= 0) appointments.value[idx] = data;
    externalDescriptionEditing.value = false;
  } catch (e) {
    console.error(e);
  } finally {
    externalDescriptionSaving.value = false;
  }
};

const externalDurationSaving = ref(false);
const saveExternalDuration = async newDuration => {
  if (!externalEventDetails.value?.appointmentId) return;
  externalDurationSaving.value = true;
  try {
    const accountId =
      store.state.auth?.currentUser?.account_id ||
      store.getters?.getCurrentAccountId;
    const url = `/api/v1/accounts/${accountId}/lead_appointments/${externalEventDetails.value.appointmentId}`;
    // eslint-disable-next-line no-undef
    const { data } = await axios.patch(url, { duration_min: newDuration });
    externalEventDetails.value = {
      ...externalEventDetails.value,
      duration_min: data.duration_min,
    };
    const idx = appointments.value.findIndex(
      a => a.id === externalEventDetails.value.appointmentId
    );
    if (idx >= 0) appointments.value[idx] = data;
  } catch (e) {
    console.error('[external-event] duration update failed', e);
    emitter.emit('newToastMessage', {
      message: 'Erro ao atualizar duração',
      type: 'error',
    });
  } finally {
    externalDurationSaving.value = false;
  }
};

const externalStatusSaving = ref(false);
const saveExternalStatus = async newStatus => {
  if (!externalEventDetails.value?.appointmentId) return;
  externalStatusSaving.value = true;
  try {
    const accountId =
      store.state.auth?.currentUser?.account_id ||
      store.getters?.getCurrentAccountId;
    const url = `/api/v1/accounts/${accountId}/lead_appointments/${externalEventDetails.value.appointmentId}`;
    // eslint-disable-next-line no-undef
    const { data } = await axios.patch(url, { status: newStatus });
    externalEventDetails.value = {
      ...externalEventDetails.value,
      status: data.status,
    };
    const idx = appointments.value.findIndex(
      a => a.id === externalEventDetails.value.appointmentId
    );
    if (idx >= 0) appointments.value[idx] = data;
    emitter.emit('newToastMessage', {
      message: 'Status atualizado',
      type: 'success',
    });
  } catch (e) {
    console.error('[external-event] status update failed', e);
    emitter.emit('newToastMessage', {
      message: 'Erro ao atualizar status',
      type: 'error',
    });
  } finally {
    externalStatusSaving.value = false;
  }
};

const selectedItem = ref(null);

// Adicionar ref para controlar o estado de drag & drop
const dragOverCell = ref(null);
// Estado pra preview do drag-drop em time grid: mostra hora:minuto alvo
const dragTimeTarget = ref(null); // { hour, minute, x, y } durante drag
const dragOverHourSlot = ref(null); // { date, hour, half } pra highlight de metade
// Filtro Agenda: quando true, mostra apenas items com scheduled_at (esconde
// deadline-only). Persistido em localStorage pra UX consistente.
const onlyScheduledFilter = ref(
  localStorage.getItem('agenda:onlyScheduled') === '1'
);

// Lista de agendamentos do dia selecionado, ordenados por horario.
// Cada entry tem dados pra renderizar um card no sidebar.
const appointmentsForSelectedDay = computed(() => {
  const day = selectedDate.value || currentMonth.value || new Date();
  const targetY = day.getFullYear();
  const targetM = day.getMonth();
  const targetD = day.getDate();
  const list = [];

  agendaFilteredItems.value.forEach(item => {
    const sa = item.item_details?.scheduled_at;
    if (!sa) return;
    const d = parseEventDate(sa);
    if (!d || Number.isNaN(d.getTime())) return;
    if (
      d.getFullYear() !== targetY ||
      d.getMonth() !== targetM ||
      d.getDate() !== targetD
    )
      return;
    list.push({
      id: item.id,
      title: item.title || item.item_details?.title || '(sem titulo)',
      scheduledAt: d,
      stageColor: item.stageColor,
      stageName: item.stageName,
      funnelName: item.funnelName,
      _raw: item,
    });
  });

  // Tambem inclui appointments externos (Google sem kanban linkado) do dia
  appointments.value.forEach(appt => {
    if (appt.linked_kanban_item_id) return;
    const d = parseEventDate(appt.scheduled_at);
    if (!d || Number.isNaN(d.getTime())) return;
    if (
      d.getFullYear() !== targetY ||
      d.getMonth() !== targetM ||
      d.getDate() !== targetD
    )
      return;
    list.push({
      id: 'appt-' + appt.id,
      title: appt.contact?.name || appt.description || 'Evento Google',
      scheduledAt: d,
      stageColor: '#3b82f6',
      stageName: 'Externo',
      funnelName: 'Google Calendar',
      _raw: appt,
      _isExternal: true,
    });
  });

  return list.sort((a, b) => a.scheduledAt - b.scheduledAt);
});

const formatTimeShort = d => {
  if (!d) return '';
  return (
    String(d.getHours()).padStart(2, '0') +
    ':' +
    String(d.getMinutes()).padStart(2, '0')
  );
};

const handleSidebarAppointmentClick = entry => {
  if (entry._isExternal) {
    handleEventClick({
      ...entry._raw,
      _isExternalAppointment: true,
      _appointmentId: entry._raw.id,
    });
  } else {
    handleEventClick(entry._raw);
  }
};

// Adicionar nova ref para controlar a data selecionada no mini calendário
const selectedMiniDate = ref(new Date());

// Quando usuario clica numa data no mini-calendario, sincroniza com a view
// principal: muda selectedDate (e currentMonth se mes diferente). O viewMode
// nao eh alterado — se estiver em Dia, mostra esse dia; em Semana, a semana
// que contem esse dia; em Mes, navega pro mes desse dia.
const handleMiniCalendarDateClick = date => {
  selectedMiniDate.value = date;
  selectedDate.value = new Date(date);
  if (
    date.getFullYear() !== currentMonth.value.getFullYear() ||
    date.getMonth() !== currentMonth.value.getMonth()
  ) {
    currentMonth.value = new Date(date);
  }
};


// Ref para controlar o estado do painel lateral
const isPanelOpen = ref(true);

// Refs para modal de mover funil
const showMoveFunnelModal = ref(false);
const availableFunnels = ref([]);
const selectedFunnelId = ref(null);
const selectedStage = ref(null);
const isMovingItem = ref(false);

// Ref para modal de itens sem data
const showNoDateModal = ref(false);
const noDateItemSearchQuery = ref('');
const noDateItemConversationFilter = ref('all');
const showWeekSlotItemsModal = ref(false);
const weekSlotModalDate = ref(null);
const weekSlotModalHour = ref(null);
const weekSlotModalItems = ref([]);
const weekSlotItemSearchQuery = ref('');
const weekSlotItemConversationFilter = ref('all');

// Modal: todos os itens de um dia (a partir de "+X mais")
const showDayEventsModal = ref(false);
const dayEventsModalDate = ref(null);
const dayEventsModalEvents = ref([]);
const dayEventsSearchQuery = ref('');
const dayEventsConversationFilter = ref('all');

const openDayEventsModal = (date, events) => {
  dayEventsModalDate.value = date;
  dayEventsModalEvents.value = events;
  dayEventsSearchQuery.value = '';
  dayEventsConversationFilter.value = 'all';
  showDayEventsModal.value = true;
};

const closeDayEventsModal = () => {
  showDayEventsModal.value = false;
  dayEventsModalDate.value = null;
  dayEventsModalEvents.value = [];
  dayEventsSearchQuery.value = '';
  dayEventsConversationFilter.value = 'all';
};

const handleDayEventInModal = event => {
  closeDayEventsModal();
  handleEventClick(event);
};

// Computed para converter stages do funil para o formato columns esperado
const funnelColumns = computed(() => {
  const selectedFunnel = store.getters['funnel/getSelectedFunnel'];
  if (!selectedFunnel?.stages) return [];

  // Converte o objeto stages para array de columns
  const columns = Object.entries(selectedFunnel.stages)
    .map(([stageId, stageData]) => ({
      id: stageId,
      title: stageData.name,
      color: stageData.color,
      position: stageData.position,
      description: stageData.description,
    }))
    .sort((a, b) => a.position - b.position);

  return columns;
});

// Computed para usar as columns corretas (fallback para props se necessário)
const columnsToUse = computed(() => {
  return funnelColumns.value.length > 0 ? funnelColumns.value : props.columns;
});

const selectedAgendaOfferId = ref(null);
const agendaOfferOptionsList = ref([]);

const itemMatchesAgendaOfferFilter = (item, offerId) => {
  if (offerId === null || offerId === undefined || offerId === '') return true;
  const oid = Number(offerId);
  if (Number.isNaN(oid)) return true;
  const offers = item?.item_details?.offers;
  if (!Array.isArray(offers) || offers.length === 0) return false;
  return offers.some(o => {
    if (o?.manual) return false;
    const id = o?.id ?? o?.offer_id;
    return id != null && Number(id) === oid;
  });
};

const agendaFilteredItems = computed(() => {
  let filtered = items.value;
  // Filtro 'apenas agendamentos': esconde items que so tem deadline_at (sem
  // scheduled_at). Util pra ver so compromissos com hora marcada.
  if (onlyScheduledFilter.value) {
    filtered = filtered.filter(item => item.item_details?.scheduled_at);
  }
  if (
    selectedAgendaOfferId.value !== null &&
    selectedAgendaOfferId.value !== '' &&
    selectedAgendaOfferId.value !== undefined
  ) {
    filtered = filtered.filter(item =>
      itemMatchesAgendaOfferFilter(item, selectedAgendaOfferId.value)
    );
  }
  return filtered;
});

// Persiste o filtro entre reloads
const toggleOnlyScheduled = () => {
  onlyScheduledFilter.value = !onlyScheduledFilter.value;
  localStorage.setItem(
    'agenda:onlyScheduled',
    onlyScheduledFilter.value ? '1' : '0'
  );
};

const miniCalendarStageLegend = computed(() => {
  return columnsToUse.value
    .filter(stage => stage?.title)
    .map(stage => ({
      id: stage.id,
      name: stage.title,
      color: stage.color || '#64748B',
    }));
});

// Computed para dias do mês atual
const daysInMonth = computed(() => {
  const year = currentMonth.value.getFullYear();
  const month = currentMonth.value.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const days = [];

  // Adicionar dias do mês anterior para completar a primeira semana
  const firstDayOfWeek = firstDay.getDay();
  for (let i = firstDayOfWeek - 1; i >= 0; i--) {
    const date = new Date(year, month, -i);
    const events = getEventsForDate(date);
    days.push({
      date,
      isCurrentMonth: false,
      events,
      valueSum: sumUniqueItemValuesForDay(events),
    });
  }

  // Adicionar dias do mês atual
  for (let date = 1; date <= lastDay.getDate(); date++) {
    const currentDate = new Date(year, month, date);
    const events = getEventsForDate(currentDate);
    days.push({
      date: currentDate,
      isCurrentMonth: true,
      events,
      valueSum: sumUniqueItemValuesForDay(events),
    });
  }

  // Adicionar dias do próximo mês para completar a última semana
  const remainingDays = 42 - days.length; // 6 semanas * 7 dias = 42
  for (let i = 1; i <= remainingDays; i++) {
    const date = new Date(year, month + 1, i);
    const events = getEventsForDate(date);
    days.push({
      date,
      isCurrentMonth: false,
      events,
      valueSum: sumUniqueItemValuesForDay(events),
    });
  }

  return days;
});

// Adicionar computed para dias baseado no modo de visualização
const visibleDays = computed(() => {
  if (viewMode.value === 'week') {
    return getWeekDays();
  }
  if (viewMode.value === 'day') {
    const date = new Date(selectedDate.value || new Date());
    const events = getEventsForDate(date);
    return [
      {
        date,
        isCurrentMonth: date.getMonth() === currentMonth.value.getMonth(),
        events,
        valueSum: sumUniqueItemValuesForDay(events),
      },
    ];
  }
  return daysInMonth.value;
});

// Função para obter os dias da semana atual
const getWeekDays = () => {
  const today = selectedDate.value || new Date();
  const start = new Date(today);
  start.setDate(start.getDate() - start.getDay()); // Começa no domingo

  const days = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    const events = getEventsForDate(date);
    days.push({
      date,
      isCurrentMonth: date.getMonth() === currentMonth.value.getMonth(),
      events,
      valueSum: sumUniqueItemValuesForDay(events),
    });
  }
  return days;
};

// Atualizar o computed weeks para usar visibleDays
const weeks = computed(() => {
  const days =
    viewMode.value === 'week' || viewMode.value === 'day'
      ? visibleDays.value
      : daysInMonth.value;
  const weeks = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days.slice(i, i + 7));
  }
  return weeks;
});

// Computed para nomes dos dias da semana
const weekDays = computed(() => {
  const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  return days;
});

// Função auxiliar para normalizar datas vindas da API
const parseEventDate = rawDate => {
  if (!rawDate) return null;

  // Se for string no formato apenas de data (YYYY-MM-DD), interpretar como data local
  if (typeof rawDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(rawDate)) {
    const [year, month, day] = rawDate.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  // Fallback para datas completas com horário/timezone
  return new Date(rawDate);
};

// Função auxiliar para verificar se item tem due_date do checklist na data
const hasChecklistDueDateOnDate = (item, date) => {
  const compareYear = date.getFullYear();
  const compareMonth = date.getMonth();
  const compareDay = date.getDate();

  const checklist = item.checklist || [];
  // Garantir que checklist seja um array
  const checklistArray = Array.isArray(checklist) ? checklist : [];
  return checklistArray.some(checklistItem => {
    const dueDate = checklistItem.due_date;
    if (!dueDate) return false;

    const checklistDate = parseEventDate(dueDate);
    if (!checklistDate || Number.isNaN(checklistDate.getTime())) return false;

    return (
      checklistDate.getFullYear() === compareYear &&
      checklistDate.getMonth() === compareMonth &&
      checklistDate.getDate() === compareDay
    );
  });
};

// Atualizar a função getEventsForDate para usar o horário local
const getEventsForDate = date => {
  const compareYear = date.getFullYear();
  const compareMonth = date.getMonth();
  const compareDay = date.getDate();

  const events = [];

  agendaFilteredItems.value.forEach(item => {
    // Verifica scheduled_at ou deadline_at do item
    const itemDate =
      item.item_details?.scheduled_at || item.item_details?.deadline_at;
    if (itemDate) {
      const eventDate = parseEventDate(itemDate);
      if (eventDate && !Number.isNaN(eventDate.getTime())) {
        if (
          eventDate.getFullYear() === compareYear &&
          eventDate.getMonth() === compareMonth &&
          eventDate.getDate() === compareDay
        ) {
          events.push({
            ...item,
            isFromChecklist: false,
            checklistItem: null,
          });
        }
      }
    }

    // Verifica due_date dos itens do checklist
    if (hasChecklistDueDateOnDate(item, date)) {
      // Para cada item do checklist que tem due_date nesta data, cria um evento separado
      const checklist = item.checklist || [];
      // Garantir que checklist seja um array
      const checklistArray = Array.isArray(checklist) ? checklist : [];
      checklistArray.forEach(checklistItem => {
        const dueDate = checklistItem.due_date;
        if (!dueDate) return;

        const checklistDate = parseEventDate(dueDate);
        if (!checklistDate || Number.isNaN(checklistDate.getTime())) return;

        if (
          checklistDate.getFullYear() === compareYear &&
          checklistDate.getMonth() === compareMonth &&
          checklistDate.getDate() === compareDay
        ) {
          events.push({
            ...item,
            isFromChecklist: true,
            checklistItem: checklistItem,
          });
        }
      });
    }
  });

  // Inclui LeadAppointments do Google Calendar que não foram criados via kanban
  // (linked_kanban_item_id ausente). Aparecem como eventos "externos" no grid.
  appointments.value.forEach(appt => {
    if (appt.linked_kanban_item_id) return; // já está em items via kanban
    const eventDate = parseEventDate(appt.scheduled_at);
    if (!eventDate || Number.isNaN(eventDate.getTime())) return;
    if (
      eventDate.getFullYear() !== compareYear ||
      eventDate.getMonth() !== compareMonth ||
      eventDate.getDate() !== compareDay
    )
      return;
    const apptTitle = appt.contact?.name
      ? appt.description
        ? `${appt.contact.name} — ${appt.description}`
        : appt.contact.name
      : appt.description || 'Evento Google Calendar';
    events.push({
      id: `appt-${appt.id}`,
      _isExternalAppointment: true,
      _appointmentId: appt.id,
      _status: appt.status || 'scheduled',
      _durationMin: appt.duration_min || null,
      _contactConversationDisplayId:
        appt.contact?.latest_conversation_display_id || null,
      contact: appt.contact || null,
      title: apptTitle,
      description: appt.description || '',
      priority: 'none',
      funnelName: appt.origin === 'google' ? 'Google Calendar' : 'Externo',
      stageName: appt.origin === 'google' ? 'Google' : 'Externo',
      stageColor: '#4285F4',
      item_details: {
        scheduled_at: appt.scheduled_at,
        title: apptTitle,
        customer_name: appt.contact?.name || '',
      },
      conversation: null,
      assigned_agents: [],
      checklist: [],
      isFromChecklist: false,
      checklistItem: null,
      _origin: appt.origin,
    });
  });

  return events;
};

// Adicionar função para navegar entre semanas
const changeWeek = direction => {
  const newDate = new Date(selectedDate.value);
  newDate.setDate(newDate.getDate() + direction * 7);
  selectedDate.value = newDate;
  currentMonth.value = new Date(newDate); // Atualiza o mês se necessário
};

// Navegar 1 dia (usado no modo "day")
const changeDay = direction => {
  const newDate = new Date(selectedDate.value);
  newDate.setDate(newDate.getDate() + direction);
  selectedDate.value = newDate;
  currentMonth.value = new Date(newDate);
};

// Atualizar a função de mudança de mês para considerar o modo
const changeMonth = direction => {
  if (viewMode.value === 'week') {
    changeWeek(direction * 4); // Aproximadamente um mês
    return;
  }
  if (viewMode.value === 'day') {
    changeDay(direction);
    return;
  }

  const newMonth = new Date(currentMonth.value);
  newMonth.setMonth(newMonth.getMonth() + direction);
  currentMonth.value = newMonth;
  selectedDate.value = newMonth;
};

// Atualizar a função formatDate para aceitar opções
const formatDate = (date, options = { month: 'long', year: 'numeric' }) => {
  const formatted = new Intl.DateTimeFormat('pt-BR', {
    ...options,
  }).format(date);

  // Garantir que a primeira letra seja maiúscula
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const dayEventsModalDateLabel = computed(() => {
  const d = dayEventsModalDate.value;
  if (!d) return '';
  return formatDate(d, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
});

const getAgendaEventTitle = event =>
  event?.isFromChecklist
    ? event?.checklistItem?.text || t('KANBAN.AGENDA.CHECKLIST_ITEM_FALLBACK')
    : event?.title || event?.item_details?.title || t('KANBAN.UNTITLED_ITEM');

const dayEventsModalFilteredEvents = computed(() => {
  const query = dayEventsSearchQuery.value.trim().toLowerCase();
  const conversationFilter = dayEventsConversationFilter.value;

  return dayEventsModalEvents.value.filter(event => {
    const title = getAgendaEventTitle(event).toLowerCase();
    const matchesTitle = !query || title.includes(query);
    if (!matchesTitle) return false;

    if (conversationFilter === 'with') {
      return hasLinkedConversation(event);
    }

    if (conversationFilter === 'without') {
      return !hasLinkedConversation(event);
    }

    return true;
  });
});

// Função para verificar se é hoje
const isToday = date => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

// Adicionar o computed para eventos do dia
const todayEvents = computed(() => {
  const today = new Date();
  return agendaFilteredItems.value
    .filter(item => {
      const itemDate =
        item.item_details?.scheduling_type === 'deadline'
          ? item.item_details?.deadline_at
          : item.item_details?.scheduled_at;

      if (!itemDate) return false;

      const eventDate = parseEventDate(itemDate);
      if (!eventDate || Number.isNaN(eventDate.getTime())) return false;

      return (
        eventDate.getFullYear() === today.getFullYear() &&
        eventDate.getMonth() === today.getMonth() &&
        eventDate.getDate() === today.getDate()
      );
    })
    .sort((a, b) => {
      const dateA = parseEventDate(
        a.item_details?.scheduling_type === 'deadline'
          ? a.item_details?.deadline_at
          : a.item_details?.scheduled_at
      );
      const dateB = parseEventDate(
        b.item_details?.scheduling_type === 'deadline'
          ? b.item_details?.deadline_at
          : b.item_details?.scheduled_at
      );
      return dateA - dateB;
    });
});

// Atualizar a função para converter UTC para horário local
const toLocalTime = date => {
  if (!date) return null;
  try {
    const utcDate = new Date(date);
    // Extrair apenas o horário no formato HH:mm
    return `${String(utcDate.getHours()).padStart(2, '0')}:${String(
      utcDate.getMinutes()
    ).padStart(2, '0')}`;
  } catch (error) {
    console.error('Erro ao converter data:', error);
    return null;
  }
};

// Simplificar para mostrar apenas o título do evento
const formatEventTime = date => {
  if (!date) return '';
  return ''; // Não exibir horário
};

const getEventsForHour = (events, hour) => {
  return events.filter(event => {
    const itemDate = event.isFromChecklist
      ? event.checklistItem?.due_date
      : event.item_details?.scheduled_at ||
        event.item_details?.deadline_at ||
        event.created_at;

    if (!itemDate) return false;
    const eventDate = parseEventDate(itemDate);
    if (!eventDate || Number.isNaN(eventDate.getTime())) return false;
    return eventDate.getHours() === hour;
  });
};

// Removido: lógica de posicionamento por horário

// Valor numérico do item (item_details.value) para somas na agenda
const parseKanbanItemValue = item => {
  const raw = item?.item_details?.value;
  if (raw === null || raw === undefined || raw === '') return null;
  const n =
    typeof raw === 'number'
      ? raw
      : parseFloat(String(raw).replace(/\s/g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : null;
};

// Soma valores únicos por item no dia (evita contar o mesmo card várias vezes por checklist)
const sumUniqueItemValuesForDay = events => {
  if (!events?.length) return 0;
  const seen = new Set();
  let sum = 0;
  events.forEach(ev => {
    if (!ev?.id || seen.has(ev.id)) return;
    seen.add(ev.id);
    const v = parseKanbanItemValue(ev);
    if (v !== null) sum += v;
  });
  return sum;
};

// Adicionar computed para formatar valor
const formatValue = value => {
  if (!value) return null;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

// Adicionar função para buscar dados do agente
const fetchAgentDetails = async agentId => {
  if (!agentId) return null;
  if (agents.value[agentId]) return agents.value[agentId];

  try {
    // Buscar todos os agentes se ainda não tivermos buscado
    if (Object.keys(agents.value).length === 0) {
      const { data } = await AgentAPI.get();
      // Mapear os agentes por ID para acesso mais rápido
      data.forEach(agent => {
        agents.value[agent.id] = agent;
      });
    }

    return agents.value[agentId] || null;
  } catch (error) {
    console.error('Erro ao carregar agente:', error);
    return null;
  }
};

// Carrega LeadAppointments globais (Google Calendar pull) — usado pra
// preencher a Agenda com eventos que não vieram do kanban.
const fetchAppointments = async () => {
  try {
    const accountId =
      store.state.auth?.currentUser?.account_id ||
      store.getters?.getCurrentAccountId;
    if (!accountId) return;
    const selectedFunnel = store.getters['funnel/getSelectedFunnel'];
    const funnelId = selectedFunnel?.id;
    // janela: 60 dias atras ate 90 dias adiante (cobre mes visivel + buffer)
    const from = new Date();
    from.setDate(from.getDate() - 60);
    const to = new Date();
    to.setDate(to.getDate() + 90);
    const params = new URLSearchParams({
      from: from.toISOString(),
      to: to.toISOString(),
    });
    if (funnelId) params.set('funnel_id', funnelId);
    const url = `/api/v1/accounts/${accountId}/lead_appointments?${params.toString()}`;
    // axios é global no chatwoot (configurado em main.js)
    // eslint-disable-next-line no-undef
    const { data } = await axios.get(url);
    appointments.value = Array.isArray(data) ? data : [];
  } catch (e) {
    console.warn('[AgendaTab] fetchAppointments failed', e?.message || e);
    appointments.value = [];
  }
};

// Atualizar a função fetchKanbanItems
const fetchKanbanItems = async ({ showLoading = true } = {}) => {
  try {
    if (showLoading) {
      isLoading.value = true;
    }

    // Carregar todos os agentes primeiro para evitar requisições repetidas.
    if (Object.keys(agents.value).length === 0) {
      const { data } = await AgentAPI.get();
      data.forEach(agent => {
        agents.value[agent.id] = agent;
      });
    }

    // Buscar items do funnel SELECIONADO (per-funnel filter eh intencional —
    // user quer ver so a agenda do funnel onde estao trabalhando).
    const selectedFunnel = store.getters['funnel/getSelectedFunnel'];
    if (!selectedFunnel) {
      console.error('Nenhum funil selecionado');
      items.value = [];
      return;
    }

    let allItems = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await KanbanAPI.getItems(selectedFunnel.id, page);
      const responseData = response.data;

      if (responseData && responseData.items) {
        // Nova estrutura paginada
        allItems = allItems.concat(responseData.items);
        hasMore = responseData.pagination?.has_more || false;

        // Atualiza o contador semanal se fornecido (geralmente na primeira página)
        if (responseData.weekly_count !== undefined && page === 1) {
          weeklyCount.value = responseData.weekly_count;
        }
      } else if (Array.isArray(responseData)) {
        // Estrutura antiga (array direto)
        allItems = responseData;
        hasMore = false;
      } else {
        // Resposta vazia ou inválida
        hasMore = false;
      }

      page++;

      // Proteção contra loop infinito
      if (page > 100) {
        console.warn('Limite de páginas atingido, interrompendo busca');
        break;
      }
    }

    let apiData = allItems;

    // Mapear os itens e buscar dados dos agentes
    const itemsWithAgents = await Promise.all(
      apiData.map(async item => {
        const agentId = item.item_details?.agent_id;
        const agent = agentId ? agents.value[agentId] : null;

        // Estruturar assigned_agents como KanbanItem.vue espera
        let assignedAgents = [];
        if (item.assigned_agents && item.assigned_agents.length > 0) {
          // Se já tem assigned_agents da API, usar eles
          assignedAgents = item.assigned_agents;
        } else if (agent) {
          // Criar assigned_agents baseado no agente único (compatibilidade)
          assignedAgents = [
            {
              id: agent.id,
              name: agent.name,
              avatar_url: agent.avatar_url || agent.thumbnail || '',
              assigned_at: null,
              assigned_by: null,
            },
          ];
        }

        return {
          id: item.id,
          title: item.item_details?.title || '',
          description: item.item_details?.description || '',
          priority: item.item_details?.priority || 'none',
          funnel_id: item.funnel_id,
          funnelName: item.funnel?.name || selectedFunnel?.name || '',
          funnel: item.funnel || null,
          funnel_stage: item.funnel_stage,
          position: item.position,

          // Dados importantes que podem ser perdidos
          stage_entered_at: item.stage_entered_at || null,
          conversation_display_id: item.conversation_display_id || null,
          assigned_agents: assignedAgents,
          checklist: item.checklist || [],
          conversation: item.conversation || null,

          item_details: {
            ...item.item_details,
            _agent: agent,
          },

          stageName: (() => {
            const itemFunnelStages = item.funnel?.stages || {};
            const stageData = itemFunnelStages[item.funnel_stage];
            return (
              stageData?.name ||
              columnsToUse.value.find(col => col.id === item.funnel_stage)
                ?.title ||
              item.funnel_stage ||
              ''
            );
          })(),
          stageColor: (() => {
            const itemFunnelStages = item.funnel?.stages || {};
            const stageData = itemFunnelStages[item.funnel_stage];
            return (
              stageData?.color ||
              columnsToUse.value.find(col => col.id === item.funnel_stage)
                ?.color ||
              '#64748B'
            );
          })(),
          created_at: item.created_at,
          custom_attributes: item.custom_attributes || {},

          // Dados do agente para compatibilidade
          agent: agent || null,
        };
      })
    );

    items.value = itemsWithAgents;

    // Também buscar appointments do Google Calendar em paralelo.
    fetchAppointments();
  } catch (e) {
    console.error('Erro ao carregar itens:', e);
    error.value = t('KANBAN.ERRORS.FETCH_ITEMS');
  } finally {
    isLoading.value = false;
  }
};
// Handlers
const handleViewChange = view => {
  emit('switch-view', view);
};

const handleDateClick = (date, events) => {
  selectedDate.value = date;
  showDateOptionsModal.value = true;
};

const handleFilter = filters => {
  activeFilters.value = filters;
};

const handleSearch = query => {
  searchQuery.value = query;
};

const handleItemCreated = async item => {
  if (!item) return;
  showAddModal.value = false;
  showDateOptionsModal.value = false;
  await fetchKanbanItems({ showLoading: false });
};

// Funções para o modal de opções de data
const handleCreateNewItem = () => {
  showDateOptionsModal.value = false;
  showAddModal.value = true;
};

const handleScheduleExistingItem = () => {
  showDateOptionsModal.value = false;
  scheduleItemSearchQuery.value = '';
  scheduleItemConversationFilter.value = 'all';
  showScheduleItemModal.value = true;
};

const hasLinkedConversation = item =>
  Boolean(
    item?.item_details?.conversation_id ||
      item?.conversation_display_id ||
      item?.conversation?.id
  );

const scheduleModalFilteredItems = computed(() => {
  const query = scheduleItemSearchQuery.value.trim().toLowerCase();
  const conversationFilter = scheduleItemConversationFilter.value;

  return agendaFilteredItems.value.filter(item => {
    const itemTitle =
      item?.title || item?.item_details?.title || t('KANBAN.UNTITLED_ITEM');
    const matchesTitle = !query || itemTitle.toLowerCase().includes(query);

    if (!matchesTitle) return false;

    if (conversationFilter === 'with') {
      return hasLinkedConversation(item);
    }

    if (conversationFilter === 'without') {
      return !hasLinkedConversation(item);
    }

    return true;
  });
});

const handleScheduleItem = async itemId => {
  try {
    await handleCardDrop(itemId, selectedDate.value, false);
    showScheduleItemModal.value = false;
  } catch (error) {
    console.error('Erro ao agendar item:', error);
  }
};

// Função para preparar item para detalhes - com dados completos como KanbanItem
const prepareItemForDetails = item => {
  // Buscar dados completos do item original
  const fullItem = items.value.find(i => i.id === item.id) || item;

  // Usar as novas funções de agente para garantir compatibilidade total com KanbanItem
  const agentInfo = getAgentInfo(fullItem);
  const primaryAgent = getPrimaryAgent(fullItem);

  return {
    id: fullItem.id || null,
    title: fullItem.item_details?.title || fullItem.title || '',
    description:
      fullItem.item_details?.description || fullItem.description || '',
    priority: fullItem.item_details?.priority || fullItem.priority || 'none',
    funnel_id: fullItem.funnel_id || null,
    funnel_stage: fullItem.funnel_stage || null,
    position: fullItem.position || 0,

    // Dados importantes que estavam sendo perdidos
    stage_entered_at: fullItem.stage_entered_at || null,
    conversation_display_id: fullItem.conversation_display_id || null,
    assigned_agents: fullItem.assigned_agents || [],

    item_details: {
      ...{
        title: fullItem.item_details?.title || fullItem.title || '',
        description:
          fullItem.item_details?.description || fullItem.description || '',
        priority:
          fullItem.item_details?.priority || fullItem.priority || 'none',
        value: null,
        currency: 'BRL',
        deadline_at: null,
        scheduling_type: null,
        scheduled_at: null,
        agent_id: primaryAgent?.id || null,
        rescheduled: false,
        rescheduling_history: [],
        notes: [],
        activities: [],
        conversation_id: null,
      },
      ...(fullItem.item_details || {}),
      _agent: primaryAgent, // Usar primaryAgent das novas funções
    },

    stageName:
      fullItem.stageName ||
      columnsToUse.value.find(col => col.id === fullItem.funnel_stage)?.title ||
      '',
    stageColor:
      fullItem.stageColor ||
      columnsToUse.value.find(col => col.id === fullItem.funnel_stage)?.color ||
      '#64748B',
    created_at: fullItem.created_at || new Date().toISOString(),
    custom_attributes: fullItem.custom_attributes || {},
    checklist: fullItem.checklist || [],

    // Dados do agente - usar primaryAgent para garantir compatibilidade com KanbanItem
    agent: primaryAgent || fullItem.agent || null,

    // Dados da conversa se disponível
    conversation: fullItem.conversation || null,
  };
};

// Função para abrir detalhes do item
const handleEventClick = event => {
  if (!event || !event.id) {
    return;
  }

  // Eventos externos (Google Calendar sem kanban_item linkado) — abre modal
  // com detalhes do evento + ações disponíveis (abrir conversa do contato,
  // buscar conversas, ou só ver os dados).
  if (event._isExternalAppointment) {
    externalEventDetails.value = {
      title: event.title || event.description || 'Evento Google Calendar',
      description: event.description || '',
      scheduled_at: event.item_details?.scheduled_at,
      contact: event.contact || null,
      conversation_display_id: event._contactConversationDisplayId,
      origin: event._origin || 'externo',
      appointmentId: event._appointmentId,
      status: event._status || 'scheduled',
      duration_min: event._durationMin || null,
    };
    showExternalEventModal.value = true;
    return;
  }

  selectedItem.value = prepareItemForDetails(event);
  showItemDetails.value = true;
};

// Função para fechar detalhes do item
const handleCloseDetails = () => {
  showItemDetails.value = false;
  selectedItem.value = null;
};

// Resolve o conversation_display_id pra o botao Ver Conversa: usa o direto
// no externalEventDetails se existir, ou cai pro latest_conversation_display_id
// do contato vinculado.
const resolvedConversationDisplayId = computed(() => {
  const direct = externalEventDetails.value?.conversation_display_id;
  if (direct) return direct;
  return (
    externalEventDetails.value?.contact?.latest_conversation_display_id || null
  );
});

const navigateToLeadConversation = () => {
  const cid = resolvedConversationDisplayId.value;
  if (!cid) return;
  const acct = store.state.auth?.currentUser?.account_id;
  if (!acct) return;
  window.location.href = `/app/accounts/${acct}/conversations/${cid}`;
};

const formatDateOnlyLocal = d => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

// Atualizar a função handleCardDrop para armazenar datas de remarcação
const handleCardDrop = async (itemId, date, isReschedule = false) => {
  try {
    const item = items.value.find(i => i.id === itemId);
    if (!item) return;

    const details = item.item_details || {};
    const target = new Date(date);

    let updatedItemDetails;

    if (details.scheduled_at) {
      const prev = parseEventDate(details.scheduled_at);
      const merged = new Date(target);
      if (prev && !Number.isNaN(prev.getTime())) {
        merged.setHours(
          prev.getHours(),
          prev.getMinutes(),
          prev.getSeconds(),
          prev.getMilliseconds()
        );
      } else {
        merged.setHours(12, 0, 0, 0);
      }

      const currentDate = details.scheduled_at;
      const toDate = merged.toISOString();

      updatedItemDetails = {
        ...details,
        scheduling_type: 'schedule',
        scheduled_at: toDate,
        rescheduled: isReschedule,
        rescheduling_history: isReschedule
          ? [
              ...(details.rescheduling_history || []),
              {
                from_date: currentDate,
                to_date: toDate,
                changed_at: new Date().toISOString(),
              },
            ]
          : [],
      };
    } else {
      const currentDate = details.deadline_at || details.scheduled_at;
      const dateOnly = formatDateOnlyLocal(target);

      updatedItemDetails = {
        ...details,
        scheduling_type: 'deadline',
        deadline_at: dateOnly,
        rescheduled: isReschedule,
        rescheduling_history: isReschedule
          ? [
              ...(details.rescheduling_history || []),
              {
                from_date: currentDate,
                to_date: dateOnly,
                changed_at: new Date().toISOString(),
              },
            ]
          : [],
      };
    }

    const payload = {
      funnel_id: item.funnel_id,
      funnel_stage: item.funnel_stage,
      position: item.position,
      item_details: updatedItemDetails,
      custom_attributes: item.custom_attributes || {},
    };

    await KanbanAPI.updateItem(itemId, payload);
    await fetchKanbanItems();
  } catch (error) {
    console.error('Erro ao definir prazo:', error);
  }
};

const handleChecklistItemDueDateDrop = async (
  itemId,
  checklistItemId,
  date
) => {
  try {
    const dueDate = formatDateOnlyLocal(new Date(date));
    await KanbanAPI.updateChecklistItem(itemId, checklistItemId, {
      due_date: dueDate,
    });
    await fetchKanbanItems({ showLoading: false });
  } catch (err) {
    console.error('Erro ao atualizar prazo do checklist:', err);
  }
};

// Atualizar as funções de drag & drop
const allowDrop = (e, date) => {
  e.preventDefault();
  dragOverCell.value = date;
};

const handleDragLeave = () => {
  dragOverCell.value = null;
};

const handleDrop = async (e, date) => {
  e.preventDefault();
  const rawId =
    e.dataTransfer.getData('itemId') || e.dataTransfer.getData('text/plain');
  const itemId = parseInt(rawId, 10);
  const isReschedule = e.dataTransfer.getData('isReschedule') === 'true';
  const checklistItemId = e.dataTransfer.getData('checklistItemId');
  if (!itemId) return;

  const item = items.value.find(i => i.id === itemId);

  if (checklistItemId) {
    const checklistItem = item?.checklist?.find(
      ci => ci.id === checklistItemId
    );
    if (checklistItem?.due_date) {
      const from = parseEventDate(checklistItem.due_date);
      if (from && !Number.isNaN(from.getTime()) && isSameDay(from, date)) {
        dragOverCell.value = null;
        return;
      }
    }
    dragOverCell.value = null;
    await handleChecklistItemDueDateDrop(itemId, checklistItemId, date);
    return;
  }

  if (item) {
    const itemDate =
      item.item_details?.scheduled_at || item.item_details?.deadline_at;
    const from = parseEventDate(itemDate);
    if (from && !Number.isNaN(from.getTime()) && isSameDay(from, date)) {
      dragOverCell.value = null;
      return;
    }
  }

  dragOverCell.value = null;
  await handleCardDrop(itemId, date, isReschedule);
};

const handleAgendaItemDragStart = (e, event) => {
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData('itemId', String(event.id));
  e.dataTransfer.setData('text/plain', String(event.id));
  e.dataTransfer.setData('isReschedule', 'true');
  if (event.isFromChecklist && event.checklistItem?.id) {
    e.dataTransfer.setData('checklistItemId', String(event.checklistItem.id));
  }
};

// Drop em slot de hora (week/day view) — muda data E hora do evento.
// Reaproveita logica do handleCardDrop mas com hora explicita do slot.
const handleHourSlotDrop = async (e, date, hour) => {
  const rawId =
    e.dataTransfer.getData('itemId') || e.dataTransfer.getData('text/plain');
  const itemId = parseInt(rawId, 10);
  if (!itemId) return;
  const item = items.value.find(i => i.id === itemId);
  if (!item) return;
  const target = new Date(date);
  // Snap pra 30min: usa Y do cursor relativo a celula. Upper half (0-50%) = :00,
  // lower half (50-100%) = :30. Garante alinhamento visual com o local exato do drop.
  const rect = e.currentTarget.getBoundingClientRect();
  const relativeY = e.clientY - rect.top;
  const minutes = relativeY > rect.height / 2 ? 30 : 0;
  target.setHours(hour, minutes, 0, 0);
  const details = item.item_details || {};
  const updatedDetails = {
    ...details,
    scheduling_type: 'schedule',
    scheduled_at: target.toISOString(),
    rescheduled: true,
    rescheduling_history: [
      ...(details.rescheduling_history || []),
      {
        from_date: details.scheduled_at,
        to_date: target.toISOString(),
        changed_at: new Date().toISOString(),
      },
    ],
  };
  try {
    await KanbanAPI.updateItem(itemId, {
      funnel_id: item.funnel_id,
      funnel_stage: item.funnel_stage,
      position: item.position,
      item_details: updatedDetails,
      custom_attributes: item.custom_attributes || {},
    });
    await fetchKanbanItems();
  } catch (err) {
    console.error('Erro ao reagendar para o horario:', err);
  } finally {
    dragOverHourSlot.value = null;
    dragTimeTarget.value = null;
  }
};

// Dragover handler em hour slot: calcula metade alvo (00 ou 30) baseado em
// posicao do cursor e atualiza estado pra UI mostrar feedback visual.
const handleHourSlotDragover = (e, date, hour) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = 'move';
  const rect = e.currentTarget.getBoundingClientRect();
  const relativeY = e.clientY - rect.top;
  const isLowerHalf = relativeY > rect.height / 2;
  const half = isLowerHalf ? '30' : '00';
  dragOverHourSlot.value = { date, hour, half };
  dragTimeTarget.value = {
    hour,
    minute: isLowerHalf ? 30 : 0,
    x: e.clientX,
    y: e.clientY,
  };
};

// Limpa state quando sai da hour slot ou solta
const handleHourSlotDragleave = () => {
  dragOverHourSlot.value = null;
  dragTimeTarget.value = null;
};

// Adicione esta função para lidar com a edição
// SiteUp V2 (2026-08-11): editar é DENTRO do card. Antes isto abria o
// formulário de 8 abas por cima da agenda — dois lugares para mudar o mesmo
// dado, e um deles sem o contexto do card.
const handleItemEdit = item => {
  selectedItem.value = prepareItemForDetails(item);
  showItemDetails.value = true;
};

// Adicione esta função para lidar com o item atualizado
const handleItemUpdated = async item => {
  showItemDetails.value = false;
  await fetchKanbanItems({ showLoading: false });
};

// Lifecycle hooks
const loadAgendaOfferOptions = async () => {
  if (!isStacklab) return;
  try {
    const response = await offersAPI.getOffers();
    const data = response.data;
    const list = Array.isArray(data) ? data : [];
    agendaOfferOptionsList.value = list.map(o => ({
      id: o.id,
      name: o.name || o.title || String(o.id),
    }));
  } catch {
    agendaOfferOptionsList.value = [];
  }
};

onMounted(async () => {
  syncAgendaQuietestDark();
  agendaQuietestDarkObserver = new MutationObserver(syncAgendaQuietestDark);
  agendaQuietestDarkObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  // Real-time refresh: agendamentos criados em qualquer lugar do app
  // (KanbanActions na conversa, KanbanItemForm, etc) emitem esses eventos.
  // Refetch silencioso (sem loading) atualiza a UI imediatamente.
  emitter.on('kanbanItemCreated', handleKanbanItemRealtime);
  emitter.on('kanbanItemUpdated', handleKanbanItemRealtime);
  emitter.on('kanbanItemDeleted', handleKanbanItemRealtime);
  emitter.on('kanban.item.updated', handleKanbanItemRealtime);

  await fetchKanbanItems();
  await loadAgendaOfferOptions();
});

onBeforeUnmount(() => {
  emitter.off('kanbanItemCreated', handleKanbanItemRealtime);
  emitter.off('kanbanItemUpdated', handleKanbanItemRealtime);
  emitter.off('kanbanItemDeleted', handleKanbanItemRealtime);
  emitter.off('kanban.item.updated', handleKanbanItemRealtime);

  agendaQuietestDarkObserver?.disconnect();
});

// Watch para atualizar quando o funil mudar
watch(
  () => store.getters['funnel/getSelectedFunnel'],
  async (newFunnel, oldFunnel) => {
    if (newFunnel?.id !== oldFunnel?.id) {
      selectedAgendaOfferId.value = null;
    }
    await fetchKanbanItems();
  }
);

// Adicionar watch para o viewMode
watch(viewMode, newMode => {
  if (newMode === 'week') {
    selectedDate.value = new Date(); // Reset para a semana atual
  }
});

// Adicionar computed para eventos do dia selecionado
const selectedDayEvents = computed(() => {
  return agendaFilteredItems.value
    .filter(item => {
      const itemDate =
        item.item_details?.scheduling_type === 'deadline'
          ? item.item_details?.deadline_at
          : item.item_details?.scheduled_at;

      if (!itemDate) return false;

      const eventDate = parseEventDate(itemDate);
      if (!eventDate || Number.isNaN(eventDate.getTime())) return false;
      return (
        eventDate.getFullYear() === selectedMiniDate.value.getFullYear() &&
        eventDate.getMonth() === selectedMiniDate.value.getMonth() &&
        eventDate.getDate() === selectedMiniDate.value.getDate()
      );
    })
    .sort((a, b) => {
      const dateA = parseEventDate(
        a.item_details?.scheduled_at || a.item_details?.deadline_at
      );
      const dateB = parseEventDate(
        b.item_details?.scheduled_at || b.item_details?.deadline_at
      );
      return dateA - dateB;
    });
});

// Itens sem data (sem deadline_at nem scheduled_at)
const itemsWithoutDate = computed(() => {
  return agendaFilteredItems.value.filter(item => {
    const deadline = item.item_details?.deadline_at;
    const scheduled = item.item_details?.scheduled_at;
    return !deadline && !scheduled;
  });
});

// Agente atual (para "Meus itens hoje")
const currentUserId = computed(() => store.getters.getCurrentUser?.id ?? null);

// Meus itens hoje: itens com prazo no dia selecionado atribuídos ao agente atual
const myItemsToday = computed(() => {
  const userId = currentUserId.value;
  if (!userId) return [];
  const day = selectedMiniDate.value;
  const y = day.getFullYear();
  const m = day.getMonth();
  const d = day.getDate();
  return agendaFilteredItems.value.filter(item => {
    const itemDate =
      item.item_details?.deadline_at || item.item_details?.scheduled_at;
    if (!itemDate) return false;
    const eventDate = parseEventDate(itemDate);
    if (!eventDate || Number.isNaN(eventDate.getTime())) return false;
    const sameDay =
      eventDate.getFullYear() === y &&
      eventDate.getMonth() === m &&
      eventDate.getDate() === d;
    if (!sameDay) return false;
    const assigned = item.assigned_agents || [];
    return assigned.some(agent => agent.id === userId);
  });
});

// Resumo do dia selecionado (total e meus)
const daySummary = computed(() => {
  const day = selectedMiniDate.value;
  const dayEvents = getEventsForDate(day);
  const total = dayEvents.length;
  const myCount = myItemsToday.value.length;
  return { total, myCount };
});

const selectedDaySidebarLabel = computed(() =>
  formatDate(selectedMiniDate.value, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  })
);

// Dia do mês visível no mini calendário com mais eventos (mesma contagem que getEventsForDate)
const busiestDayInMonth = computed(() => {
  const currentMonthDays = daysInMonth.value.filter(d => d.isCurrentMonth);
  if (!currentMonthDays.length) return null;
  let best = null;
  for (const d of currentMonthDays) {
    const n = d.events.length;
    if (n === 0) continue;
    if (
      !best ||
      n > best.count ||
      (n === best.count && d.date.getTime() < best.date.getTime())
    ) {
      best = { date: d.date, count: n, valueSum: d.valueSum };
    }
  }
  return best;
});

// Dia do mês com menos eventos (entre dias com pelo menos 1 item; empate: data mais antiga)
const quietestDayInMonth = computed(() => {
  const currentMonthDays = daysInMonth.value.filter(d => d.isCurrentMonth);
  if (!currentMonthDays.length) return null;
  let best = null;
  for (const d of currentMonthDays) {
    const n = d.events.length;
    if (n === 0) continue;
    if (
      !best ||
      n < best.count ||
      (n === best.count && d.date.getTime() < best.date.getTime())
    ) {
      best = { date: d.date, count: n };
    }
  }
  return best;
});

const agendaQuietestDark = ref(
  typeof document !== 'undefined' && document.body.classList.contains('dark')
);

const syncAgendaQuietestDark = () => {
  agendaQuietestDark.value =
    typeof document !== 'undefined' && document.body.classList.contains('dark');
};

let agendaQuietestDarkObserver = null;

const quietestDayCardStyle = computed(() => ({
  backgroundColor: agendaQuietestDark.value ? '#422006' : '#FFFBEB',
  borderColor: agendaQuietestDark.value ? '#CA8A04' : '#FACC15',
  borderWidth: '1px',
  borderStyle: 'solid',
}));

const quietestDayTitleStyle = computed(() => ({
  color: agendaQuietestDark.value ? '#FDE68A' : '#92400E',
}));

const quietestDayPrimaryTextStyle = computed(() => ({
  color: agendaQuietestDark.value ? '#FEF3C7' : '#451A03',
}));

const quietestDaySecondaryTextStyle = computed(() => ({
  color: agendaQuietestDark.value ? '#FACC15' : '#B45309',
}));

const quietestDayBtnHover = ref(false);
const quietestDayBtnFocus = ref(false);

const quietestDayButtonStyle = computed(() => ({
  backgroundColor: quietestDayBtnHover.value
    ? agendaQuietestDark.value
      ? '#451A03'
      : '#FEF3C7'
    : 'transparent',
  boxShadow: quietestDayBtnFocus.value ? '0 0 0 2px #FACC15' : 'none',
}));

const itemsWithoutDateBtnHover = ref(false);
const itemsWithoutDateBtnFocus = ref(false);

const itemsWithoutDateButtonStyle = computed(() => {
  const dark = agendaQuietestDark.value;
  const hover = itemsWithoutDateBtnHover.value;
  return {
    width: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.375rem',
    minHeight: '2rem',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    borderRadius: '0.5rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: dark ? '#EA580C' : '#F97316',
    backgroundColor: hover
      ? dark
        ? '#7C2D12'
        : '#FED7AA'
      : dark
        ? '#431407'
        : '#FFEDD5',
    color: dark ? '#FDBA74' : '#C2410C',
    boxShadow: itemsWithoutDateBtnFocus.value ? '0 0 0 2px #F97316' : 'none',
    transition: 'background-color 100ms ease, box-shadow 100ms ease',
  };
});

const itemsWithoutDateBadgeStyle = computed(() => ({
  backgroundColor: agendaQuietestDark.value ? '#9A3412' : '#FDBA74',
  color: agendaQuietestDark.value ? '#FFEDD5' : '#7C2D12',
}));

const openNoDateModal = () => {
  noDateItemSearchQuery.value = '';
  noDateItemConversationFilter.value = 'all';
  showNoDateModal.value = true;
};

const closeNoDateModal = () => {
  noDateItemSearchQuery.value = '';
  noDateItemConversationFilter.value = 'all';
  showNoDateModal.value = false;
};

const closeWeekSlotItemsModal = () => {
  showWeekSlotItemsModal.value = false;
  weekSlotModalDate.value = null;
  weekSlotModalHour.value = null;
  weekSlotModalItems.value = [];
  weekSlotItemSearchQuery.value = '';
  weekSlotItemConversationFilter.value = 'all';
};

const openItemFromNoDateList = item => {
  showNoDateModal.value = false;
  selectedItem.value = item;
  showItemDetails.value = true;
};

// Helper: checklist concluídos / total para exibir no modal
const getChecklistSummary = item => {
  const list = item?.checklist || [];
  if (!Array.isArray(list) || list.length === 0) return null;
  const completed = list.filter(i => i.completed).length;
  return { completed, total: list.length };
};

const getStageColor = item => {
  return item?.funnel?.stages?.[item.funnel_stage]?.color || null;
};

const noDateModalFilteredItems = computed(() => {
  const query = noDateItemSearchQuery.value.trim().toLowerCase();
  const conversationFilter = noDateItemConversationFilter.value;

  return itemsWithoutDate.value.filter(item => {
    const itemTitle =
      item?.item_details?.title ||
      item?.title ||
      t('KANBAN.ITEM_DETAILS.UNTITLED_ITEM');
    const matchesTitle = !query || itemTitle.toLowerCase().includes(query);

    if (!matchesTitle) return false;

    if (conversationFilter === 'with') {
      return hasLinkedConversation(item);
    }

    if (conversationFilter === 'without') {
      return !hasLinkedConversation(item);
    }

    return true;
  });
});

const weekSlotModalDateLabel = computed(() => {
  const d = weekSlotModalDate.value;
  if (!d) return '';
  return formatDate(d, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
});

const weekSlotHourLabel = computed(() => {
  if (typeof weekSlotModalHour.value !== 'number') return '';
  return `${String(weekSlotModalHour.value).padStart(2, '0')}:00`;
});

const weekSlotModalFilteredItems = computed(() => {
  const query = weekSlotItemSearchQuery.value.trim().toLowerCase();
  const conversationFilter = weekSlotItemConversationFilter.value;

  return weekSlotModalItems.value.filter(item => {
    const itemTitle =
      item?.item_details?.title ||
      item?.title ||
      t('KANBAN.ITEM_DETAILS.UNTITLED_ITEM');
    const matchesTitle = !query || itemTitle.toLowerCase().includes(query);

    if (!matchesTitle) return false;

    if (conversationFilter === 'with') {
      return hasLinkedConversation(item);
    }

    if (conversationFilter === 'without') {
      return !hasLinkedConversation(item);
    }

    return true;
  });
});

const openWeekSlotItemsModal = (date, events, hour) => {
  weekSlotModalDate.value = date;
  weekSlotModalHour.value = hour;
  weekSlotItemSearchQuery.value = '';
  weekSlotItemConversationFilter.value = 'all';
  weekSlotModalItems.value = getEventsForHour(events, hour).filter(
    event => !event.isFromChecklist
  );
  showWeekSlotItemsModal.value = true;
};

const openItemFromWeekSlotList = item => {
  closeWeekSlotItemsModal();
  handleEventClick(item);
};

// Função auxiliar para comparar se duas datas são o mesmo dia
const isSameDay = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

// Removido: computed para time-slotted events

// Handler real-time: quando agendamento eh criado/atualizado em qualquer
// lugar do app (conversa, kanban detail, modal de agenda), refetch a lista
// pra UI refletir imediatamente sem precisar refresh manual.
const handleKanbanItemRealtime = () => {
  fetchKanbanItems({ showLoading: false });
};

// Handlers para os novos componentes do mini calendário
const openMiniCalendarMonthView = () => {
  miniCalendarView.value = 'months';
};

const handleMiniCalendarSetView = (calendarType, period) => {
  if (period === PERIOD_YEAR) {
    miniCalendarView.value = 'years';
  } else if (period === PERIOD_MONTH) {
    miniCalendarView.value = 'months';
  } else {
    miniCalendarView.value = 'days';
  }
};

const handleMiniCalendarSelectMonth = monthIndex => {
  const newDate = new Date(currentMonth.value);
  newDate.setMonth(monthIndex);
  currentMonth.value = newDate;
  selectedMiniDate.value = new Date(newDate); // Sincronizar selectedMiniDate
  miniCalendarView.value = 'days';
};

const handleMiniCalendarSelectYear = year => {
  const newDate = new Date(currentMonth.value);
  newDate.setFullYear(year);
  currentMonth.value = newDate;
  selectedMiniDate.value = new Date(newDate); // Sincronizar selectedMiniDate
  miniCalendarView.value = 'months'; // Mudar para visualização de meses após selecionar o ano
};

const handleMiniCalendarPrev = () => {
  // Usado por CalendarMonth para navegar para o ano anterior
  const newDate = new Date(currentMonth.value);
  newDate.setFullYear(newDate.getFullYear() - 1);
  currentMonth.value = newDate;
  selectedMiniDate.value = new Date(newDate);
};

const handleMiniCalendarNext = () => {
  // Usado por CalendarMonth para navegar para o próximo ano
  const newDate = new Date(currentMonth.value);
  newDate.setFullYear(newDate.getFullYear() + 1);
  currentMonth.value = newDate;
  selectedMiniDate.value = new Date(newDate);
};

// Computed para informações do agente - replicando funcionalidade do KanbanItem
const getAgentInfo = item => {
  // Prioriza assigned_agents se existir e tiver conteúdo
  if (item.assigned_agents && item.assigned_agents.length > 0) {
    return item.assigned_agents.map(agent => ({
      id: agent.id,
      name: agent.name,
      avatar_url: agent.avatar_url || agent.thumbnail || '',
      assigned_at: agent.assigned_at || null,
      assigned_by: agent.assigned_by || null,
    }));
  }

  // Fallback para agente único se disponível
  if (item.agent || item.item_details?._agent) {
    const agent = item.agent || item.item_details._agent;
    return [
      {
        id: agent.id,
        name: agent.name,
        avatar_url: agent.avatar_url || agent.thumbnail || '',
        assigned_at: null,
        assigned_by: null,
      },
    ];
  }

  // Retorna array vazio se não houver agente
  return [];
};

// Computed para obter o agente principal - replicando funcionalidade do KanbanItem
const getPrimaryAgent = item => {
  const agentInfo = getAgentInfo(item);
  return agentInfo.length > 0 ? agentInfo[0] : null;
};

// Função para alternar o estado do painel lateral
const togglePanel = () => {
  isPanelOpen.value = !isPanelOpen.value;
};

// Funções auxiliares para o header do modal de detalhes
const getStageTintBadgeStyle = event => {
  const base = event?.stageColor || '#64748B';
  if (event?.isFromChecklist) {
    return {
      backgroundColor: '#f1f5f9',
      color: '#64748b',
      boxShadow: 'inset 0 0 0 1px #cbd5e1',
    };
  }
  return {
    backgroundColor: `${base}40`,
    color: base,
    boxShadow: `inset 0 0 0 1px ${base}`,
  };
};

/** Retorna { labelKey, style } para badge na célula (ganho / perdido) ou null */
const agendaStatusBadge = event => {
  const status = event?.item_details?.status?.toLowerCase();
  if (status === 'won') {
    return { labelKey: 'KANBAN.WON', style: getStageTintBadgeStyle(event) };
  }
  if (status === 'lost') {
    return { labelKey: 'KANBAN.LOST', style: getStageTintBadgeStyle(event) };
  }
  return null;
};

const getItemStatusInfo = item => {
  const status = item?.item_details?.status?.toLowerCase();

  const statusMap = {
    won: {
      label: 'Ganho',
      class: 'bg-green-50 dark:bg-green-900 text-green-700 dark:text-green-300',
    },
    lost: {
      label: 'Perdido',
      class: 'bg-red-50 dark:bg-red-900 text-red-700 dark:text-red-300',
    },
  };

  if (!status) {
    return {
      label: 'Aberto',
      class: 'bg-blue-50 dark:bg-blue-900 text-blue-700 dark:text-blue-300',
    };
  }

  return (
    statusMap[status] || {
      label: 'Aberto',
      class: 'bg-blue-50 dark:bg-blue-900 text-blue-700 dark:text-blue-300',
    }
  );
};

const getItemStatusClass = item => {
  return getItemStatusInfo(item).class;
};

const getItemStatusLabel = item => {
  return getItemStatusInfo(item).label;
};

const getPriorityInfo = item => {
  if (!item || !item.item_details?.priority) {
    return null;
  }
  const priority = item.item_details.priority.toLowerCase();
  if (priority === 'none') return null;

  const priorityMap = {
    high: {
      label: 'Alta',
      class: 'bg-n-ruby-3 dark:bg-n-ruby-8 text-n-ruby-9 dark:text-n-ruby-1',
    },
    medium: {
      label: 'Média',
      class:
        'bg-yellow-50 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-50',
    },
    low: {
      label: 'Baixa',
      class: 'bg-green-50 dark:bg-green-800 text-green-800 dark:text-green-50',
    },
  };

  return priorityMap[priority] || null;
};

const getConversationCustomAttributes = item => {
  const conversation = item?.conversation;
  if (!conversation?.custom_attributes) return [];

  const filtered = [];
  Object.entries(conversation.custom_attributes).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      filtered.push({ key, value });
    }
  });

  return filtered;
};

const getFormattedUpdatedAt = item => {
  if (!item?.updated_at) return '';
  try {
    const date = new Date(item.updated_at);
    return date.toLocaleString('pt-BR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    return '';
  }
};

const getFormattedDeadlineAt = item => {
  if (!item?.item_details?.deadline_at) return '';
  try {
    const date = parseEventDate(item.item_details.deadline_at);
    if (!date || Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('pt-BR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch (error) {
    return '';
  }
};

// Funções para modal de mover funil
const openMoveFunnelModal = async () => {
  try {
    const { data } = await FunnelAPI.get();
    availableFunnels.value = data;

    selectedFunnelId.value = selectedItem.value?.funnel_id;

    const currentFunnel = data.find(
      f => f.id === selectedItem.value?.funnel_id
    );
    const currentStageName = selectedItem.value?.funnel_stage;

    if (currentFunnel && currentStageName) {
      const stageKey = Object.keys(currentFunnel.stages).find(
        key => currentFunnel.stages[key].name === currentStageName
      );
      selectedStage.value = stageKey || null;
    } else {
      selectedStage.value = null;
    }

    showMoveFunnelModal.value = true;
  } catch (error) {
    console.error('Erro ao carregar funis:', error);
  }
};

const closeMoveFunnelModal = () => {
  showMoveFunnelModal.value = false;
  selectedFunnelId.value = null;
  selectedStage.value = null;
};

const moveItemToFunnel = async () => {
  if (!selectedFunnelId.value || !selectedItem.value) return;

  try {
    isMovingItem.value = true;

    await KanbanAPI.moveToFunnel(
      selectedItem.value.id,
      selectedFunnelId.value,
      selectedStage.value
    );

    emitter.emit('kanban.item.updated');

    closeMoveFunnelModal();

    await fetchKanbanItems({ showLoading: false });

    emitter.emit('newToastMessage', {
      message: 'Item movido com sucesso',
      type: 'success',
    });
  } catch (error) {
    console.error('Erro ao mover item:', error);
    emitter.emit('newToastMessage', {
      message: 'Erro ao mover item',
      type: 'error',
    });
  } finally {
    isMovingItem.value = false;
  }
};

const selectedFunnelForModal = computed(() => {
  return availableFunnels.value.find(f => f.id === selectedFunnelId.value);
});
</script>

<template>
  <div class="flex flex-col h-full bg-n-solid-1">
    <KanbanHeader
      v-model:agenda-offer-filter-id="selectedAgendaOfferId"
      :agenda-offer-options="agendaOfferOptionsList"
      :current-view="currentView"
      :search-results="filteredResults"
      :active-filters="activeFilters"
      :columns="columnsToUse"
      :kanban-items="items"
      @switch-view="handleViewChange"
      @filter="handleFilter"
      @search="handleSearch"
    />

    <div class="flex flex-1 min-h-0 flex-col">
      <div class="flex flex-1 min-h-0">
        <!-- Mini Calendar Sidebar -->
        <div
          v-show="isPanelOpen"
          class="w-[280px] border-r border-n-weak flex flex-col mini-calendar-section overflow-hidden"
        >
          <div class="p-4 flex flex-col h-full min-h-0">
            <!-- Mini Calendar Label -->
            <div class="mb-2">
              <span class="text-xs font-medium text-n-slate-11">
                {{ t('KANBAN.AGENDA.SELECT_MONTH') }}
              </span>
            </div>
            <!-- Mini Calendar Header -->
            <div
              v-if="miniCalendarView === 'days'"
              class="flex items-center justify-between mb-4"
            >
              <span
                class="text-sm font-medium text-n-slate-11 cursor-pointer hover:text-woot-500 dark:hover:text-woot-400"
                @click="openMiniCalendarMonthView"
              >
                {{ formatDate(currentMonth) }}
              </span>
              <div class="flex items-center gap-1">
                <Button variant="ghost" size="sm" @click="changeMonth(-1)">
                  <span class="i-ri-arrow-left-s-line size-3" />
                </Button>
                <Button variant="ghost" size="sm" @click="changeMonth(1)">
                  <span class="i-ri-arrow-right-s-line size-3" />
                </Button>
              </div>
            </div>

            <!-- CalendarMonth View -->
            <CalendarMonth
              v-if="miniCalendarView === 'months'"
              calendar-type="start"
              :start-current-date="currentMonth"
              :end-current-date="currentMonth"
              class="mb-4"
              @select-month="handleMiniCalendarSelectMonth"
              @set-view="handleMiniCalendarSetView"
              @prev="handleMiniCalendarPrev"
              @next="handleMiniCalendarNext"
            />

            <!-- CalendarYear View -->
            <CalendarYear
              v-if="miniCalendarView === 'years'"
              calendar-type="start"
              :start-current-date="currentMonth"
              :end-current-date="currentMonth"
              class="mb-4"
              @select-year="handleMiniCalendarSelectYear"
              @prev="() => {}"
              @next="() => {}"
            />

            <!-- Mini Calendar Grid (apenas se a visualização for 'days') -->
            <div
              v-if="miniCalendarView === 'days'"
              class="mini-calendar mb-6 flex-shrink-0"
            >
              <!-- Mini Week Days - Substituído por CalendarWeekLabel -->
              <CalendarWeekLabel class="mb-2" />

              <!-- Mini Days Grid -->
              <div class="grid grid-cols-7 gap-2">
                <div
                  v-for="day in daysInMonth"
                  :key="day.date"
                  class="aspect-square flex items-center justify-center text-xs rounded-full cursor-pointer"
                  :class="{
                    'bg-n-solid-2': !day.isCurrentMonth,
                    'bg-n-solid-1': day.isCurrentMonth,
                    'text-n-slate-10': !day.isCurrentMonth,
                    'text-n-slate-12': day.isCurrentMonth,
                    'bg-woot-500 text-white':
                      isToday(day.date) && !day.events.length,
                    'ring-1 ring-woot-500': isSameDay(
                      day.date,
                      selectedMiniDate
                    ),
                    relative: day.events.length > 0,
                  }"
                  @click="handleMiniCalendarDateClick(day.date)"
                >
                  {{ day.date.getDate() }}
                  <!-- Indicador de eventos -->
                  <div
                    v-if="day.events.length > 0"
                    class="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-woot-500"
                  />
                </div>
              </div>
            </div>

            <!-- Quick actions below mini calendar -->
            <div class="mt-4 flex min-h-0 flex-1 flex-col gap-3">
              <button
                type="button"
                class="shrink-0 text-sm font-medium focus:outline-none"
                :style="itemsWithoutDateButtonStyle"
                @mouseenter="itemsWithoutDateBtnHover = true"
                @mouseleave="itemsWithoutDateBtnHover = false"
                @focusin="itemsWithoutDateBtnFocus = true"
                @focusout="itemsWithoutDateBtnFocus = false"
                @click="openNoDateModal"
              >
                <span class="i-ri-calendar-line size-3.5 mr-1.5 shrink-0" />
                {{ t('KANBAN.AGENDA.ITEMS_WITHOUT_DATE') }}
                <span
                  v-if="itemsWithoutDate.length > 0"
                  class="ml-1.5 px-1.5 py-0.5 text-[10px] font-semibold rounded-full"
                  :style="itemsWithoutDateBadgeStyle"
                >
                  {{ itemsWithoutDate.length }}
                </span>
              </button>

              <div
                class="no-scrollbar flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto"
              >
                <!-- AGENDAMENTOS HOJE: lista de cards do dia selecionado, ordenados por horario.
                     Substitui as estatisticas que existiam aqui (Meus itens hoje, Resumo do dia,
                     Dia com mais/menos itens) por algo mais acionavel e visual. -->
                <div class="flex items-center justify-between gap-2">
                  <span
                    class="text-xs font-semibold uppercase tracking-wide text-n-slate-11"
                  >
                    Agendamentos do dia
                  </span>
                  <span
                    class="text-xs font-normal text-n-slate-10 tabular-nums shrink-0 text-right"
                  >
                    {{ selectedDaySidebarLabel }}
                  </span>
                </div>

                <div
                  v-if="appointmentsForSelectedDay.length === 0"
                  class="text-xs text-n-slate-10 py-6 text-center border border-dashed border-n-weak rounded-xl"
                >
                  Nenhum agendamento neste dia.
                </div>

                <div v-else class="flex flex-col gap-2">
                  <button
                    v-for="entry in appointmentsForSelectedDay"
                    :key="entry.id"
                    type="button"
                    class="w-full text-left rounded-xl border border-n-weak bg-n-solid-2 p-3 hover:border-woot-300 hover:shadow-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-woot-500/40"
                    @click="handleSidebarAppointmentClick(entry)"
                  >
                    <div class="flex items-center gap-2 mb-1">
                      <span
                        class="text-sm font-semibold text-n-slate-12 tabular-nums"
                      >
                        {{ formatTimeShort(entry.scheduledAt) }}
                      </span>
                      <span
                        v-if="entry.stageName"
                        class="text-[10px] uppercase font-semibold tracking-wider px-2 py-0.5 rounded-full"
                        :style="{
                          backgroundColor:
                            (entry.stageColor || '#64748B') + '30',
                          color: entry.stageColor || '#64748B',
                        }"
                      >
                        {{ entry.stageName }}
                      </span>
                    </div>
                    <div class="text-sm font-medium text-n-slate-12 truncate">
                      {{ entry.title }}
                    </div>
                    <div
                      v-if="entry.funnelName"
                      class="text-[11px] text-n-slate-11 mt-0.5 truncate"
                    >
                      {{ entry.funnelName }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Main Calendar -->
        <div class="flex-1 flex flex-col min-h-0">
          <!-- Main Calendar Header -->
          <div class="flex-shrink-0 bg-n-solid-1">
            <div class="flex items-center justify-between px-4 py-4">
              <div class="flex min-w-0 items-center gap-3">
                <Button variant="ghost" size="sm" @click="togglePanel">
                  <svg
                    v-if="isPanelOpen"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-panel-right-open-icon lucide-panel-right-open opacity-50 text-n-slate-11"
                  >
                    <rect width="18" height="18" x="3" y="3" rx="2" />
                    <path d="M15 3v18" />
                    <path d="m10 15-3-3 3-3" />
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-panel-right-close-icon lucide-panel-right-close opacity-50 text-n-slate-11"
                  >
                    <rect width="18" height="18" x="3" y="3" rx="2" />
                    <path d="M15 3v18" />
                    <path d="m8 9 3 3-3 3" />
                  </svg>
                </Button>
                <h2 class="shrink-0 text-xl font-extrabold text-n-slate-12">
                  {{
                    formatDate(
                      viewMode === 'week' || viewMode === 'day'
                        ? selectedDate
                        : currentMonth
                    )
                  }}
                </h2>
                <div class="flex min-w-0 items-center gap-2 flex-wrap">
                  <div
                    v-for="stage in miniCalendarStageLegend"
                    :key="stage.id"
                    class="flex items-center gap-1"
                  >
                    <span
                      class="w-2 h-2 rounded-full shrink-0"
                      :style="{ backgroundColor: stage.color }"
                    />
                    <span
                      class="text-[11px] leading-none text-n-slate-11 truncate max-w-[96px]"
                      :title="stage.name"
                    >
                      {{ stage.name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <Button
                  variant="ghost"
                  color="slate"
                  size="sm"
                  @click="
                    selectedDate = new Date();
                    currentMonth = new Date();
                  "
                >
                  {{ t('KANBAN.AGENDA.VIEW_MODES.TODAY') }}
                </Button>
                <div
                  class="flex border border-n-weak rounded-xl overflow-hidden"
                >
                  <Button
                    variant="ghost"
                    size="sm"
                    class="px-3 py-1.5 border-r border-n-weak rounded-none"
                    :color="viewMode === 'month' ? 'blue' : 'slate'"
                    :class="{
                      'bg-n-solid-2 text-woot-600 dark:text-woot-400':
                        viewMode === 'month',
                      'text-n-slate-12 hover:bg-n-alpha-2/50':
                        viewMode !== 'month',
                    }"
                    @click="viewMode = 'month'"
                  >
                    {{ t('KANBAN.AGENDA.VIEW_MODES.MONTH') }}
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    class="px-3 py-1.5 rounded-none"
                    :color="viewMode === 'week' ? 'blue' : 'slate'"
                    :class="{
                      'bg-n-solid-2 text-woot-600 dark:text-woot-400':
                        viewMode === 'week',
                      'text-n-slate-12 hover:bg-n-alpha-2/50':
                        viewMode !== 'week',
                    }"
                    @click="viewMode = 'week'"
                  >
                    <div class="flex items-center">
                      <span>{{ t('KANBAN.AGENDA.VIEW_MODES.WEEK') }}</span>
                      <span
                        v-if="weeklyCount > 0"
                        class="ml-1.5 px-1.5 py-0.5 text-[10px] leading-3 font-bold bg-woot-500 text-white rounded-full"
                      >
                        {{ weeklyCount }}
                      </span>
                    </div>
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    class="px-3 py-1.5 border-l border-n-weak rounded-none"
                    :color="viewMode === 'day' ? 'blue' : 'slate'"
                    :class="{
                      'bg-n-solid-2 text-woot-600 dark:text-woot-400':
                        viewMode === 'day',
                      'text-n-slate-12 hover:bg-n-alpha-2/50':
                        viewMode !== 'day',
                    }"
                    @click="viewMode = 'day'"
                  >
                    <span>Dia</span>
                  </Button>
                </div>
                <!-- Filtro: mostra so cards com scheduled_at (esconde deadline-only) -->
                <label
                  class="ml-2 inline-flex items-center gap-2 cursor-pointer select-none px-3 py-1.5 rounded-xl border border-n-weak hover:bg-n-alpha-2/50"
                  :class="
                    onlyScheduledFilter
                      ? 'bg-woot-50 dark:bg-woot-900/30 border-woot-300 dark:border-woot-700'
                      : ''
                  "
                >
                  <input
                    type="checkbox"
                    :checked="onlyScheduledFilter"
                    class="accent-woot-500 cursor-pointer"
                    @change="toggleOnlyScheduled"
                  />
                  <span class="text-xs font-medium text-n-slate-12">
                    Apenas agendamentos
                  </span>
                </label>
              </div>
            </div>

            <!-- Week Days Header -->
            <div
              class="border-b border-n-weak bg-n-solid-2/50"
              :class="
                viewMode === 'week'
                  ? 'grid min-w-0 grid-cols-[4rem_repeat(7,minmax(0,1fr))]'
                  : viewMode === 'day'
                    ? 'grid min-w-0 grid-cols-[4rem_minmax(0,1fr)]'
                    : 'grid grid-cols-7'
              "
            >
              <div
                v-if="viewMode === 'week' || viewMode === 'day'"
                class="w-16 flex-shrink-0 border-r border-n-weak bg-n-solid-2 sticky left-0 z-20"
              />
              <div
                v-for="(day, index) in viewMode === 'week' || viewMode === 'day'
                  ? visibleDays
                  : weekDays"
                :key="index"
                class="py-2.5 text-xs font-medium text-n-slate-11 text-center border-r last:border-r-0 border-n-weak min-w-0"
              >
                <div
                  v-if="viewMode === 'week' || viewMode === 'day'"
                  class="flex flex-col items-center gap-1 w-full px-1"
                >
                  <span class="text-[10px] uppercase opacity-60">{{
                    weekDays[day.date.getDay()]
                  }}</span>
                  <div
                    class="flex items-center justify-center gap-0.5 w-full min-w-0"
                  >
                    <span
                      class="text-sm font-bold shrink-0"
                      :class="isToday(day.date) ? 'text-woot-500' : ''"
                      >{{ day.date.getDate() }}</span>
                    <span
                      v-if="day.valueSum > 0"
                      class="text-[10px] font-normal text-n-slate-10 tabular-nums leading-tight min-w-0 truncate"
                    >
                      {{ formatValue(day.valueSum) }}
                    </span>
                    <button
                      type="button"
                      class="inline-flex shrink-0 items-center justify-center rounded p-0.5 text-n-slate-11 hover:bg-n-alpha-2 hover:text-woot-600 dark:hover:text-woot-400"
                      :title="t('KANBAN.AGENDA.ADD_OR_SCHEDULE_ON_DAY')"
                      :aria-label="t('KANBAN.AGENDA.ADD_OR_SCHEDULE_ON_DAY')"
                      @click.stop="handleDateClick(day.date, day.events)"
                    >
                      <span class="i-ri-add-line size-3" />
                    </button>
                  </div>
                </div>
                <span v-else>{{ day }}</span>
              </div>
            </div>
          </div>

          <!-- Calendar Grid -->
          <div
            class="calendar-grid flex-1 overflow-y-auto"
            :data-view-mode="viewMode"
          >
            <div
              v-for="week in weeks"
              :key="week[0].date"
              :class="
                viewMode === 'week'
                  ? 'grid min-w-0 grid-cols-[4rem_repeat(7,minmax(0,1fr))]'
                  : viewMode === 'day'
                    ? 'grid min-w-0 grid-cols-[4rem_minmax(0,1fr)]'
                    : 'grid grid-cols-7'
              "
            >
              <!-- Hours Sidebar -->
              <div
                v-if="viewMode === 'week' || viewMode === 'day'"
                class="w-16 flex-shrink-0 border-r border-n-weak bg-n-alpha-1 sticky left-0 z-10"
              >
                <div
                  v-for="hour in 24"
                  :key="hour"
                  class="h-20 border-b border-n-weak/50 pr-2 pt-1 text-right"
                >
                  <span class="text-[10px] font-medium text-n-slate-10">{{ (hour - 1).toString().padStart(2, '0') }}:00</span>
                </div>
              </div>

              <div
                v-for="day in week"
                :key="day.date"
                class="calendar-day relative last:border-r-0 min-w-0"
                :class="[
                  viewMode === 'week' || viewMode === 'day' ? 'p-0' : 'p-2',
                  {
                    'bg-n-solid-2/50': !day.isCurrentMonth,
                    'bg-n-solid-2': day.isCurrentMonth,
                    today: isToday(day.date),
                    'h-full': viewMode === 'week' || viewMode === 'day',
                    'flex flex-col h-full min-w-0 overflow-hidden':
                      viewMode === 'week' || viewMode === 'day',
                    'ring-2 ring-woot-500 ring-inset bg-woot-50/40 dark:bg-woot-900/20':
                      dragOverCell && isSameDay(dragOverCell, day.date),
                  },
                ]"
                @dragover="e => allowDrop(e, day.date)"
                @dragleave="handleDragLeave"
                @drop="e => handleDrop(e, day.date)"
              >
                <div class="h-full flex flex-col">
                  <!-- Date number at the top (only for month view) -->
                  <div
                    v-if="viewMode !== 'week'"
                    class="flex items-center justify-between gap-1 p-2 pb-1 min-w-0"
                  >
                    <div class="flex items-center gap-1 min-w-0 flex-1">
                      <span
                        class="text-[10px] leading-none font-medium shrink-0"
                        :class="[
                          {
                            'text-n-slate-10 ': !day.isCurrentMonth,
                            'text-n-slate-12': day.isCurrentMonth,
                            'bg-woot-500 text-white rounded-full w-5 h-5 flex items-center justify-center':
                              isToday(day.date),
                          },
                        ]"
                      >
                        {{ day.date.getDate() }}
                      </span>
                      <span
                        v-if="day.valueSum > 0"
                        class="text-[10px] font-normal text-n-slate-10 tabular-nums truncate min-w-0"
                      >
                        {{ formatValue(day.valueSum) }}
                      </span>
                    </div>
                    <button
                      type="button"
                      class="inline-flex shrink-0 items-center justify-center rounded p-0.5 text-n-slate-11 hover:bg-n-alpha-2 hover:text-woot-600 dark:hover:text-woot-400"
                      :title="t('KANBAN.AGENDA.ADD_OR_SCHEDULE_ON_DAY')"
                      :aria-label="t('KANBAN.AGENDA.ADD_OR_SCHEDULE_ON_DAY')"
                      @click.stop="handleDateClick(day.date, day.events)"
                    >
                      <span class="i-ri-add-line size-3" />
                    </button>
                  </div>

                  <!-- Events container -->
                  <div
                    :class="[
                      viewMode === 'week' || viewMode === 'day'
                        ? 'flex-1 relative'
                        : 'flex-1 px-2 pb-2 overflow-hidden',
                    ]"
                  >
                    <!-- Events for week view -->
                    <template v-if="viewMode === 'week' || viewMode === 'day'">
                      <div
                        v-for="hour in 24"
                        :key="hour"
                        class="h-20 border-b border-n-weak/50 p-1 relative hover:bg-n-alpha-2/50 transition-colors cursor-pointer"
                        @click="
                          openWeekSlotItemsModal(day.date, day.events, hour - 1)
                        "
                        @dragover.prevent="
                          e => handleHourSlotDragover(e, day.date, hour - 1)
                        "
                        @dragleave.prevent="handleHourSlotDragleave"
                        @drop.stop.prevent="
                          handleHourSlotDrop($event, day.date, hour - 1)
                        "
                      >
                        <div class="day-events-container space-y-1">
                          <div
                            v-for="event in getEventsForHour(
                              day.events,
                              hour - 1
                            )"
                            :key="
                              event.isFromChecklist
                                ? `${event.id}-${event.checklistItem?.id || event.checklistItem?.text}`
                                : event.id
                            "
                            class="event-item w-full min-w-0 max-w-full overflow-hidden text-xs px-2 py-1 rounded truncate cursor-grab active:cursor-grabbing hover:opacity-90 border-0 border-l-0"
                            :class="[
                              event._status === 'cancelled'
                                ? 'line-through opacity-50'
                                : '',
                            ]"
                            :draggable="
                              !event._isExternalAppointment &&
                              (!event.isFromChecklist ||
                                Boolean(event.checklistItem?.id))
                            "
                            :style="{
                              backgroundColor: event.isFromChecklist
                                ? '#f1f5f9'
                                : event.stageColor + '40',
                              color: event.isFromChecklist
                                ? '#64748b'
                                : event.stageColor,
                              border: 'none',
                              borderLeftWidth: 0,
                            }"
                            @dragstart="
                              handleAgendaItemDragStart($event, event)
                            "
                            @click.stop="handleEventClick(event)"
                          >
                            <div class="flex items-center gap-1.5 min-w-0">
                              <span
                                v-if="!event._isExternalAppointment"
                                class="shrink-0 tabular-nums text-[10px] font-medium text-n-slate-11"
                                >#{{ event.id }}</span>
                              <span
                                v-else
                                class="shrink-0 text-[10px] font-medium text-blue-500 dark:text-blue-400"
                                >📅</span>
                              <svg
                                v-if="event.isFromChecklist"
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-list-check-icon lucide-list-check flex-shrink-0 opacity-80"
                              >
                                <path d="M16 5H3" />
                                <path d="M16 12H3" />
                                <path d="M11 19H3" />
                                <path d="m15 18 2 2 4-4" />
                              </svg>
                              <span
                                class="truncate flex-1 min-w-0 max-w-full"
                                >{{
                                  event.isFromChecklist
                                    ? event.checklistItem?.text ||
                                      'Checklist Item'
                                    : event.title
                                }}</span>
                              <template
                                v-for="badge in [agendaStatusBadge(event)]"
                                :key="`${event.isFromChecklist ? event.checklistItem?.id || '' : ''}${event.id}-agenda-badge`"
                              >
                                <span
                                  v-if="badge"
                                  class="shrink-0 rounded px-1 py-px text-[9px] font-semibold uppercase tracking-wide"
                                  :style="badge.style"
                                >
                                  {{ t(badge.labelKey) }}
                                </span>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <!-- Regular events for month view -->
                    <template v-else>
                      <div class="day-events-container space-y-1">
                        <div
                          v-for="event in day.events.slice(0, 3)"
                          :key="
                            event.isFromChecklist
                              ? `${event.id}-${event.checklistItem?.id || event.checklistItem?.text}`
                              : event.id
                          "
                          class="event-item text-xs p-1 rounded truncate cursor-grab active:cursor-grabbing hover:opacity-90 border-0 border-l-0"
                          :class="[
                            event._status === 'cancelled'
                              ? 'line-through opacity-50'
                              : '',
                          ]"
                          :draggable="
                            !event._isExternalAppointment &&
                            (!event.isFromChecklist ||
                              Boolean(event.checklistItem?.id))
                          "
                          :style="{
                            backgroundColor: event.isFromChecklist
                              ? '#f1f5f9'
                              : event.stageColor + '40',
                            color: event.isFromChecklist
                              ? '#64748b'
                              : event.stageColor,
                            border: 'none',
                            borderLeftWidth: 0,
                          }"
                          @dragstart="handleAgendaItemDragStart($event, event)"
                          @click.stop="handleEventClick(event)"
                        >
                          <div class="flex items-center gap-1.5 min-w-0">
                            <span
                              v-if="!event._isExternalAppointment"
                              class="shrink-0 tabular-nums text-[10px] font-medium text-n-slate-11"
                              >#{{ event.id }}</span>
                            <span
                              v-else
                              class="shrink-0 text-[10px] font-medium text-blue-500 dark:text-blue-400"
                              >📅</span>
                            <svg
                              v-if="event.isFromChecklist"
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-list-check-icon lucide-list-check flex-shrink-0 opacity-80"
                            >
                              <path d="M16 5H3" />
                              <path d="M16 12H3" />
                              <path d="M11 19H3" />
                              <path d="m15 18 2 2 4-4" />
                            </svg>
                            <span class="truncate flex-1 min-w-0">{{
                              event.isFromChecklist
                                ? event.checklistItem?.text || 'Checklist Item'
                                : event.title
                            }}</span>
                            <template
                              v-for="badge in [agendaStatusBadge(event)]"
                              :key="`${event.isFromChecklist ? event.checklistItem?.id || '' : ''}${event.id}-agenda-badge`"
                            >
                              <span
                                v-if="badge"
                                class="shrink-0 rounded px-1 py-px text-[9px] font-semibold uppercase tracking-wide"
                                :style="badge.style"
                              >
                                {{ t(badge.labelKey) }}
                              </span>
                            </template>
                          </div>
                        </div>
                        <button
                          v-if="day.events.length > 3"
                          type="button"
                          class="text-xs text-left w-full text-woot-600 dark:text-woot-400 hover:underline cursor-pointer mt-0.5"
                          @click.stop="openDayEventsModal(day.date, day.events)"
                        >
                          {{
                            t('KANBAN.AGENDA.MORE_ITEMS_COUNT', {
                              count: day.events.length - 3,
                            })
                          }}
                        </button>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Substituir o Event Details Modal pelo KanbanItemDetails -->
    <Modal
      v-if="selectedItem && showItemDetails"
      v-model:show="showItemDetails"
      :on-close="handleCloseDetails"
      size="full-width"
    >
      <div class="flex flex-col h-full w-full bg-n-solid-1 overflow-hidden">
        <!-- Header igual ao KanbanActions -->
        <div
          class="border-b border-n-weak px-4 py-3 flex items-center justify-between"
        >
          <div class="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-chevron-left-icon lucide-chevron-left cursor-pointer text-n-slate-11"
              @click="handleCloseDetails"
            >
              <path d="m15 18-6-6 6-6" />
            </svg>
            <div class="flex items-center gap-3">
              <h2 class="text-base font-medium">
                {{ selectedItem?.item_details?.title || 'Detalhes do Item' }}
              </h2>
              <!-- Status do Item -->
              <span
                v-if="selectedItem"
                class="px-2.5 py-1 text-xs font-medium rounded-full"
                :class="getItemStatusClass(selectedItem)"
              >
                {{ getItemStatusLabel(selectedItem) }}
              </span>
              <span
                v-if="selectedItem && getPriorityInfo(selectedItem)"
                class="px-2.5 py-1 text-xs font-medium rounded-full"
                :class="getPriorityInfo(selectedItem).class"
              >
                {{ getPriorityInfo(selectedItem).label }}
              </span>
              <!-- Custom Attributes da Conversa -->
              <div
                v-if="
                  selectedItem &&
                  getConversationCustomAttributes(selectedItem).length > 0
                "
                class="flex items-center gap-2"
              >
                <span
                  v-for="attr in getConversationCustomAttributes(selectedItem)"
                  :key="attr.key"
                  class="px-1.5 py-0.5 text-[10px] font-medium bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full"
                  :title="`${attr.key}: ${attr.value}`"
                >
                  {{ attr.key }}: {{ attr.value }}
                </span>
              </div>
              <!-- Updated At -->
              <div
                v-if="selectedItem && getFormattedUpdatedAt(selectedItem)"
                class="text-[10px] text-n-slate-11 ml-2 hidden md:block"
              >
                {{ t('KANBAN.CONVERSATION_ACTIONS.UPDATED_AT') }}
                {{ getFormattedUpdatedAt(selectedItem) }}
              </div>
            </div>
          </div>

          <div v-if="selectedItem" class="flex items-center gap-3 mr-12">
            <!-- Data limite -->
            <div
              v-if="getFormattedDeadlineAt(selectedItem)"
              class="flex items-center gap-1.5 px-3 py-1.5"
              :style="{ backgroundColor: '#fef3c7', borderColor: '#d97706' }"
              style="
                border-width: 1px;
                border-radius: 8px;
                box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
                transition: all 200ms;
              "
            >
              <span
                :style="{ color: '#d97706' }"
                class="i-ri-calendar-schedule-line size-3.5 drop-shadow-sm"
              />
              <span
                class="text-xs font-medium tracking-wide"
                :style="{ color: '#d97706' }"
              >
                {{ t('KANBAN.CONVERSATION_ACTIONS.DEADLINE_LABEL') }}
                {{ getFormattedDeadlineAt(selectedItem) }}
              </span>
            </div>

            <!-- Botão de mover funil -->
            <button
              class="p-1.5 rounded-md"
              :style="{
                backgroundColor: '#3b82f6',
                color: 'white',
                borderColor: '#2563eb',
              }"
              style="
                border-width: 1px;
                border-radius: 6px;
                box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
                transition: all 200ms;
              "
              @mouseover="$event.target.style.backgroundColor = '#2563eb'"
              @mouseleave="$event.target.style.backgroundColor = '#3b82f6'"
              @click="openMoveFunnelModal"
            >
              <span class="flex items-center gap-1">
                <span class="i-ri-arrow-right-line size-3.5" />
                <span class="text-xs">{{
                  t('KANBAN.CONVERSATION_ACTIONS.MOVE_TO_FUNNEL')
                }}</span>
              </span>
            </button>

            <!-- Botão de editar -->
            <button
              class="p-1.5 rounded-md bg-n-solid-2 hover:bg-n-alpha-2 text-n-slate-12"
              @click="handleItemEdit(selectedItem)"
            >
              <span class="flex items-center gap-1">
                <span class="i-ri-pencil-line size-3.5" />
                <span class="text-xs">{{ t('KANBAN.ACTIONS.EDIT') }}</span>
              </span>
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-auto">
          <KanbanItemDetails
            v-if="selectedItem"
            :item-id="selectedItem.id"
            :show-header="false"
            :show-edit-button="false"
            @close="handleCloseDetails"
            @edit="handleItemEdit"
            @item-updated="fetchKanbanItems"
          />
        </div>
      </div>
    </Modal>

    <!-- Add Event Modal -->
    <Modal
      v-model:show="showAddModal"
      size="full-width"
      :on-close="() => (showAddModal = false)"
    >
      <div class="p-6">
        <h3 class="text-lg font-extrabold mb-4">
          {{ t('KANBAN.ADD_ITEM') }}
        </h3>
        <KanbanItemForm
          v-if="store.getters['funnel/getSelectedFunnel']"
          :funnel-id="store.getters['funnel/getSelectedFunnel'].id"
          :initial-date="selectedDate"
          @saved="handleItemCreated"
          @close="showAddModal = false"
        />
      </div>
    </Modal>

    <!-- Adicione o Modal de Edição -->

    <!-- Modal de Opções de Data -->
    <Modal
      v-model:show="showDateOptionsModal"
      size="small"
      :on-close="() => (showDateOptionsModal = false)"
    >
      <div class="p-6">
        <h3 class="text-lg font-extrabold mb-4">
          {{ t('KANBAN.AGENDA.SELECT_ACTION') }}
        </h3>
        <div class="flex flex-col gap-3">
          <Button
            variant="solid"
            color="blue"
            class="w-full"
            @click="handleCreateNewItem"
          >
            {{ t('KANBAN.AGENDA.CREATE_NEW_ITEM') }}
          </Button>
          <Button
            variant="outline"
            color="slate"
            class="w-full"
            @click="handleScheduleExistingItem"
          >
            {{ t('KANBAN.AGENDA.SCHEDULE_EXISTING_ITEM') }}
          </Button>
        </div>
      </div>
    </Modal>

    <!-- Modal de Agendar Item Existente -->
    <Modal
      v-model:show="showScheduleItemModal"
      size="medium"
      :on-close="() => (showScheduleItemModal = false)"
    >
      <div class="p-6">
        <h3 class="text-lg font-extrabold mb-4">
          {{ t('KANBAN.AGENDA.SELECT_ITEM_TO_SCHEDULE') }}
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
          <input
            v-model="scheduleItemSearchQuery"
            type="text"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
            :placeholder="t('KANBAN.AGENDA.SCHEDULE_FILTER_SEARCH_PLACEHOLDER')"
          />
          <select
            v-model="scheduleItemConversationFilter"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
          >
            <option value="all">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_ALL') }}
            </option>
            <option value="with">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITH') }}
            </option>
            <option value="without">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITHOUT') }}
            </option>
          </select>
        </div>
        <div class="max-h-96 overflow-y-auto space-y-2">
          <div
            v-for="item in scheduleModalFilteredItems"
            :key="item.id"
            class="p-3 border border-n-weak rounded-xl cursor-pointer hover:bg-n-alpha-2"
            @click="handleScheduleItem(item.id)"
          >
            <div class="font-medium text-n-slate-12">
              {{
                item.title ||
                item.item_details?.title ||
                t('KANBAN.UNTITLED_ITEM')
              }}
            </div>
            <div class="text-sm text-n-slate-11 mt-1">
              {{ item.stageName || '' }}
            </div>
          </div>
          <div
            v-if="scheduleModalFilteredItems.length === 0"
            class="text-center text-n-slate-11 py-8"
          >
            {{ t('KANBAN.AGENDA.NO_ITEMS_AVAILABLE') }}
          </div>
        </div>
      </div>
    </Modal>

    <!-- Modal: todos os itens do dia ("+X mais") -->
    <Modal
      v-model:show="showDayEventsModal"
      :on-close="closeDayEventsModal"
      :show-close-button="true"
      size="medium"
    >
      <div class="p-6">
        <div class="flex flex-wrap items-center gap-2 mb-1">
          <h3 class="text-lg font-extrabold text-n-slate-12">
            {{
              t('KANBAN.AGENDA.ITEMS_ON_DATE', {
                date: dayEventsModalDateLabel,
              })
            }}
          </h3>
          <span
            class="inline-flex min-h-[1.375rem] min-w-[1.375rem] items-center justify-center rounded-full px-2 text-xs font-semibold tabular-nums text-n-slate-12 bg-n-solid-3"
            :aria-label="
              t('KANBAN.AGENDA.DAY_EVENTS_TOTAL_BADGE', {
                count: dayEventsModalEvents.length,
              })
            "
          >
            {{ dayEventsModalFilteredEvents.length }}
          </span>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
          <input
            v-model="dayEventsSearchQuery"
            type="text"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
            :placeholder="t('KANBAN.AGENDA.SCHEDULE_FILTER_SEARCH_PLACEHOLDER')"
          />
          <select
            v-model="dayEventsConversationFilter"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
          >
            <option value="all">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_ALL') }}
            </option>
            <option value="with">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITH') }}
            </option>
            <option value="without">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITHOUT') }}
            </option>
          </select>
        </div>
        <div class="max-h-[70vh] overflow-y-auto space-y-2 mt-4">
          <template
            v-for="event in dayEventsModalFilteredEvents"
            :key="
              event.isFromChecklist
                ? `${event.id}-${event.checklistItem?.id ?? event.checklistItem?.text ?? ''}`
                : String(event.id)
            "
          >
            <button
              type="button"
              class="relative w-full text-left rounded-xl p-3 transition-colors shadow-[inset_0_0_0_1px_rgb(226,232,240)] dark:shadow-[inset_0_0_0_1px_rgb(71,85,105)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-woot-500/40"
              :class="
                event.isFromChecklist
                  ? 'bg-violet-50/60 hover:bg-violet-100/80 dark:bg-violet-950/40 dark:hover:bg-violet-900/35'
                  : 'hover:bg-n-alpha-2'
              "
              @click="handleDayEventInModal(event)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="pointer-events-none absolute top-2 right-2 h-4 w-4 shrink-0 text-n-slate-10"
                aria-hidden="true"
              >
                <path
                  d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
                />
                <circle cx="12" cy="12" r="3" />
              </svg>
              <div class="flex items-start gap-2 min-w-0 pr-6">
                <svg
                  v-if="event.isFromChecklist"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  class="flex-shrink-0 text-violet-600 dark:text-violet-400 mt-1"
                >
                  <path d="M16 5H3" />
                  <path d="M16 12H3" />
                  <path d="M11 19H3" />
                  <path d="m15 18 2 2 4-4" />
                </svg>
                <div class="min-w-0 flex-1 space-y-1.5">
                  <template v-if="event.isFromChecklist">
                    <div class="flex flex-wrap items-center gap-1.5">
                      <span
                        class="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide bg-violet-200 text-violet-900 dark:bg-violet-800/80 dark:text-violet-100"
                      >
                        {{ t('KANBAN.AGENDA.CHECKLIST_SUBITEM_BADGE') }}
                      </span>
                    </div>
                    <div
                      class="font-medium text-n-slate-12 flex items-center gap-2 min-w-0"
                    >
                      <span
                        class="shrink-0 tabular-nums text-xs font-medium text-n-slate-10"
                        >#{{ event.id }}</span>
                      <span class="min-w-0 truncate">{{
                        event.checklistItem?.text ||
                        t('KANBAN.AGENDA.CHECKLIST_ITEM_FALLBACK')
                      }}</span>
                    </div>
                    <div
                      v-if="event.title || event.item_details?.title"
                      class="text-xs text-n-slate-11 leading-snug"
                    >
                      {{
                        t('KANBAN.AGENDA.CHECKLIST_PARENT_HINT', {
                          title: event.title || event.item_details?.title,
                        })
                      }}
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="font-medium text-n-slate-12 flex items-center gap-2 min-w-0"
                    >
                      <span
                        class="shrink-0 tabular-nums text-xs font-medium text-n-slate-10"
                        >#{{ event.id }}</span>
                      <span class="min-w-0 truncate">{{
                        event.title || t('KANBAN.UNTITLED_ITEM')
                      }}</span>
                    </div>
                  </template>
                  <div
                    v-if="event.funnelName || event.stageName"
                    class="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px]"
                  >
                    <div
                      v-if="event.funnelName"
                      class="text-n-slate-11 flex items-center gap-1.5 min-w-0"
                    >
                      <span class="text-n-slate-10 shrink-0">
                        {{ t('KANBAN.AGENDA.DAY_EVENT_FUNNEL') }}:
                      </span>
                      <span
                        class="min-w-0 truncate font-medium text-n-slate-12"
                      >
                        {{ event.funnelName }}
                      </span>
                    </div>
                    <span
                      v-if="event.funnelName && event.stageName"
                      class="text-n-slate-9 shrink-0 select-none"
                      aria-hidden="true"
                    >
                      ·
                    </span>
                    <div
                      v-if="event.stageName"
                      class="text-n-slate-11 flex items-center gap-1.5 min-w-0"
                    >
                      <span class="text-n-slate-10 shrink-0">
                        {{ t('KANBAN.AGENDA.DAY_EVENT_STAGE') }}:
                      </span>
                      <span
                        class="w-2 h-2 rounded-full shrink-0"
                        :style="{
                          backgroundColor: event.stageColor || '#94a3b8',
                        }"
                      />
                      <span
                        class="min-w-0 truncate font-medium text-n-slate-12"
                      >
                        {{ event.stageName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </button>

            <!-- Phase 2.9.8 K*.3b: Quick Actions inline em cada evento da agenda.
               Aparece so quando event.conversation.contact.id e presente. -->
            <div v-if="event.conversation?.contact?.id" class="px-2 pb-2">
              <QuickActionButtons
                :contact-id="event.conversation.contact.id"
                :conversation-id="event.conversation.display_id"
                :kanban-item-id="event.id"
                context="kanban_agenda"
                @executed="$emit('item-updated')"
              />
            </div>
          </template>
          <div
            v-if="dayEventsModalFilteredEvents.length === 0"
            class="text-center text-n-slate-11 py-8"
          >
            {{ t('KANBAN.AGENDA.NO_ITEMS_AVAILABLE') }}
          </div>
        </div>
      </div>
    </Modal>

    <!-- Modal Itens sem data -->
    <Modal
      v-model:show="showNoDateModal"
      :on-close="closeNoDateModal"
      :show-close-button="true"
      size="medium"
    >
      <div class="p-6">
        <h3 class="text-lg font-extrabold text-n-slate-12 mb-4">
          {{ t('KANBAN.AGENDA.ITEMS_WITHOUT_DATE') }}
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
          <input
            v-model="noDateItemSearchQuery"
            type="text"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
            :placeholder="t('KANBAN.AGENDA.SCHEDULE_FILTER_SEARCH_PLACEHOLDER')"
          />
          <select
            v-model="noDateItemConversationFilter"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
          >
            <option value="all">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_ALL') }}
            </option>
            <option value="with">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITH') }}
            </option>
            <option value="without">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITHOUT') }}
            </option>
          </select>
        </div>
        <div class="max-h-[70vh] overflow-y-auto space-y-3">
          <button
            v-for="item in noDateModalFilteredItems"
            :key="item.id"
            type="button"
            class="w-full text-left rounded-xl border border-n-weak hover:bg-n-alpha-2 transition-colors overflow-hidden"
            :style="
              getStageColor(item)
                ? {
                    borderLeftWidth: '4px',
                    borderLeftColor: getStageColor(item),
                  }
                : {}
            "
            @click="openItemFromNoDateList(item)"
          >
            <div class="p-4">
              <div class="flex items-start justify-between gap-2">
                <div class="min-w-0 flex-1">
                  <div class="font-medium text-n-slate-12 truncate">
                    {{
                      item.item_details?.title ||
                      t('KANBAN.ITEM_DETAILS.UNTITLED_ITEM')
                    }}
                  </div>
                  <div class="flex flex-wrap items-center gap-1.5 mt-1.5">
                    <span
                      class="text-xs px-2 py-0.5 rounded-full font-medium text-n-slate-11 bg-n-alpha-2"
                    >
                      {{
                        item.funnel?.stages?.[item.funnel_stage]?.name ||
                        item.funnel_stage
                      }}
                    </span>
                    <span
                      v-if="item.funnel?.name"
                      class="text-xs text-n-slate-11"
                    >
                      {{ item.funnel.name }}
                    </span>
                    <span
                      v-if="getPriorityInfo(item)"
                      class="text-xs px-2 py-0.5 rounded-full font-medium"
                      :class="getPriorityInfo(item).class"
                    >
                      {{ getPriorityInfo(item).label }}
                    </span>
                    <span
                      class="text-xs px-2 py-0.5 rounded-full font-medium"
                      :class="getItemStatusClass(item)"
                    >
                      {{ getItemStatusLabel(item) }}
                    </span>
                  </div>
                </div>
                <span
                  class="i-ri-arrow-right-s-line size-4 flex-shrink-0 text-n-slate-10 mt-0.5"
                />
              </div>

              <div
                v-if="(item.item_details?.description || '').trim()"
                class="mt-2 text-sm text-n-slate-11 line-clamp-2"
              >
                {{ item.item_details.description }}
              </div>

              <div
                class="flex flex-wrap items-center gap-3 mt-3 pt-3 border-t border-n-weak/80"
              >
                <div
                  v-if="getAgentInfo(item).length > 0"
                  class="flex items-center gap-1.5"
                >
                  <div class="flex -space-x-1.5">
                    <span
                      v-for="agent in getAgentInfo(item).slice(0, 3)"
                      :key="agent.id"
                      class="relative inline-flex shrink-0"
                    >
                      <img
                        v-if="agent.avatar_url"
                        :src="agent.avatar_url"
                        :alt="agent.name"
                        class="w-6 h-6 rounded-full border-2 border-white object-cover"
                        @error="
                          $event.target.style.display = 'none';
                          $event.target.nextElementSibling?.classList.remove(
                            'hidden'
                          );
                        "
                      />
                      <div
                        :class="[agent.avatar_url ? 'hidden' : '']"
                        class="w-6 h-6 rounded-full border-2 border-white bg-woot-100 dark:bg-woot-900 flex items-center justify-center text-[10px] font-semibold text-woot-700 dark:text-woot-300"
                      >
                        {{ (agent.name || '?').charAt(0).toUpperCase() }}
                      </div>
                    </span>
                  </div>
                  <span class="text-xs text-n-slate-11">
                    {{
                      getAgentInfo(item)
                        .map(a => a.name)
                        .join(', ')
                    }}
                  </span>
                </div>
                <span v-else class="text-xs text-n-slate-10">
                  {{ t('KANBAN.NO_AGENT_ASSIGNED') }}
                </span>
                <template v-if="(item.item_details?.notes?.length || 0) > 0">
                  <span class="text-xs text-n-slate-10">
                    <span
                      class="i-ri-file-line size-3 inline align-middle mr-0.5"
                    />
                    {{ item.item_details.notes.length }}
                    {{ t('KANBAN.STATISTICS.NOTES').toLowerCase() }}
                  </span>
                </template>
                <template v-if="getChecklistSummary(item)">
                  <span class="text-xs text-n-slate-10">
                    <span
                      class="i-ri-kanban-view size-3 inline align-middle mr-0.5"
                    />
                    {{ getChecklistSummary(item).completed }}/{{
                      getChecklistSummary(item).total
                    }}
                    {{ t('KANBAN.STATISTICS.CHECKLIST').toLowerCase() }}
                  </span>
                </template>
                <template
                  v-if="
                    item.item_details?.conversation_id ||
                    item.conversation_display_id
                  "
                >
                  <span
                    class="text-xs text-woot-600 dark:text-woot-400"
                    :title="t('KANBAN.FORM.CONVERSATION.LABEL')"
                  >
                    <span
                      class="i-ri-chat-1-line size-3 inline align-middle mr-0.5"
                    />
                    #{{
                      item.conversation_display_id ||
                      item.item_details?.conversation_id
                    }}
                  </span>
                </template>
                <span
                  v-if="getFormattedUpdatedAt(item)"
                  class="text-xs text-n-slate-10 ml-auto"
                >
                  {{ getFormattedUpdatedAt(item) }}
                </span>
              </div>
            </div>
          </button>
          <div
            v-if="noDateModalFilteredItems.length === 0"
            class="text-center text-n-slate-11 py-8"
          >
            {{ t('KANBAN.AGENDA.NO_ITEMS_WITHOUT_DATE') }}
          </div>
        </div>
      </div>
    </Modal>

    <!-- Modal de itens por célula de horário (visão semanal) -->
    <Modal
      v-model:show="showWeekSlotItemsModal"
      :on-close="closeWeekSlotItemsModal"
      :show-close-button="true"
      size="medium"
    >
      <div class="p-6">
        <h3 class="text-lg font-extrabold text-n-slate-12 mb-1">
          {{
            t('KANBAN.AGENDA.WEEK_SLOT_ITEMS_TITLE', {
              date: weekSlotModalDateLabel,
              hour: weekSlotHourLabel,
            })
          }}
        </h3>
        <p class="text-sm text-n-slate-11 mb-4">
          {{ t('KANBAN.AGENDA.WEEK_SLOT_ITEMS_SUBTITLE') }}
        </p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
          <input
            v-model="weekSlotItemSearchQuery"
            type="text"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
            :placeholder="t('KANBAN.AGENDA.SCHEDULE_FILTER_SEARCH_PLACEHOLDER')"
          />
          <select
            v-model="weekSlotItemConversationFilter"
            class="w-full px-3 py-2 border border-n-weak rounded-xl bg-n-solid-1 text-n-slate-12"
          >
            <option value="all">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_ALL') }}
            </option>
            <option value="with">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITH') }}
            </option>
            <option value="without">
              {{ t('KANBAN.AGENDA.SCHEDULE_FILTER_CONVERSATION_WITHOUT') }}
            </option>
          </select>
        </div>
        <div class="max-h-[70vh] overflow-y-auto space-y-3">
          <button
            v-for="item in weekSlotModalFilteredItems"
            :key="item.id"
            type="button"
            class="w-full text-left rounded-xl border border-n-weak hover:bg-n-alpha-2 transition-colors overflow-hidden"
            :style="
              getStageColor(item)
                ? {
                    borderLeftWidth: '4px',
                    borderLeftColor: getStageColor(item),
                  }
                : {}
            "
            @click="openItemFromWeekSlotList(item)"
          >
            <div class="p-4">
              <div class="flex items-start justify-between gap-2">
                <div class="min-w-0 flex-1">
                  <div class="font-medium text-n-slate-12 truncate">
                    {{
                      item.item_details?.title ||
                      t('KANBAN.ITEM_DETAILS.UNTITLED_ITEM')
                    }}
                  </div>
                  <div class="flex flex-wrap items-center gap-1.5 mt-1.5">
                    <span
                      class="text-xs px-2 py-0.5 rounded-full font-medium text-n-slate-11 bg-n-alpha-2"
                    >
                      {{
                        item.funnel?.stages?.[item.funnel_stage]?.name ||
                        item.funnel_stage
                      }}
                    </span>
                    <span
                      v-if="item.funnel?.name"
                      class="text-xs text-n-slate-11"
                    >
                      {{ item.funnel.name }}
                    </span>
                    <span
                      v-if="
                        item.item_details?.conversation_id ||
                        item.conversation_display_id
                      "
                      class="text-xs text-woot-600 dark:text-woot-400"
                      :title="t('KANBAN.FORM.CONVERSATION.LABEL')"
                    >
                      <span
                        class="i-ri-chat-1-line size-3 inline align-middle mr-0.5"
                      />
                      #{{
                        item.conversation_display_id ||
                        item.item_details?.conversation_id
                      }}
                    </span>
                  </div>
                </div>
                <span
                  class="i-ri-arrow-right-s-line size-4 flex-shrink-0 text-n-slate-10 mt-0.5"
                />
              </div>
            </div>
          </button>
          <div
            v-if="weekSlotModalFilteredItems.length === 0"
            class="py-10 px-4"
          >
            <div
              class="mx-auto max-w-sm rounded-2xl border border-dashed border-n-weak bg-n-alpha-1 p-6 text-center"
            >
              <div
                class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-n-solid-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="h-7 w-7 text-n-slate-11"
                  aria-hidden="true"
                >
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <rect width="18" height="18" x="3" y="4" rx="2" />
                  <path d="M3 10h18" />
                  <path d="m9.5 14.5 5 5" />
                  <path d="m14.5 14.5-5 5" />
                </svg>
              </div>
              <p class="text-sm font-semibold text-n-slate-12">
                {{ t('KANBAN.AGENDA.WEEK_SLOT_NO_ITEMS') }}
              </p>
              <p class="mt-1 text-xs text-n-slate-11">
                {{ t('KANBAN.AGENDA.WEEK_SLOT_NO_ITEMS_HINT') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <!-- Modal de mover funil -->
    <Modal
      v-model:show="showMoveFunnelModal"
      :on-close="closeMoveFunnelModal"
      :show-close-button="true"
      size="medium"
    >
      <div class="p-6">
        <div class="flex items-center gap-3 mb-6">
          <div
            class="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-900/20"
          >
            <span class="i-ri-arrow-right-line size-5 text-blue-500" />
          </div>
          <h3 class="text-lg font-extrabold text-n-slate-12">
            {{ t('KANBAN.CONVERSATION_ACTIONS.MOVE_TO_FUNNEL') }}
          </h3>
        </div>

        <div class="space-y-6">
          <!-- Seleção de funil -->
          <div class="space-y-2">
            <label class="block text-sm font-medium text-n-slate-12">
              {{ t('KANBAN.CONVERSATION_ACTIONS.FUNNEL_SELECT_LABEL') }}
            </label>
            <select
              v-model="selectedFunnelId"
              class="w-full px-3 py-2.5 text-sm bg-n-solid-2 border border-n-weak rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
            >
              <option value="">
                {{ t('KANBAN.CONVERSATION_ACTIONS.SELECT_FUNNEL') }}
              </option>
              <option
                v-for="funnel in availableFunnels"
                :key="funnel.id"
                :value="funnel.id"
              >
                {{ funnel.name }}
              </option>
            </select>
          </div>

          <!-- Seleção de etapa -->
          <div v-if="selectedFunnelForModal" class="space-y-2">
            <label class="block text-sm font-medium text-n-slate-12">
              {{ t('KANBAN.CONVERSATION_ACTIONS.STAGE_SELECT_LABEL') }}
            </label>
            <select
              v-model="selectedStage"
              class="w-full px-3 py-2.5 text-sm bg-n-solid-2 border border-n-weak rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
            >
              <option value="">
                {{ t('KANBAN.CONVERSATION_ACTIONS.SELECT_STAGE') }}
              </option>
              <option
                v-for="(stage, stageKey) in selectedFunnelForModal.stages"
                :key="stageKey"
                :value="stageKey"
              >
                {{ stage.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-n-weak">
          <Button
            variant="ghost"
            color="slate"
            size="sm"
            @click="closeMoveFunnelModal"
          >
            {{ t('KANBAN.CONVERSATION_ACTIONS.CANCEL') }}
          </Button>
          <Button
            variant="solid"
            color="blue"
            size="sm"
            :is-loading="isMovingItem"
            :disabled="!selectedFunnelId || isMovingItem"
            @click="moveItemToFunnel"
          >
            <template v-if="!isMovingItem" #icon>
              <span class="i-ri-arrow-right-line size-4" />
            </template>
            {{
              isMovingItem
                ? t('KANBAN.CONVERSATION_ACTIONS.MOVING')
                : t('KANBAN.CONVERSATION_ACTIONS.MOVE_BUTTON')
            }}
          </Button>
        </div>
      </div>
    </Modal>

    <!-- Modal: detalhes de evento externo (Google Calendar sem kanban_item) -->
    <Modal
      v-model:show="showExternalEventModal"
      :on-close="
        () => {
          showExternalEventModal = false;
          externalEventDetails = null;
        }
      "
      :show-close-button="true"
      size="medium"
    >
      <div v-if="externalEventDetails" class="p-6 space-y-5">
        <div class="flex items-start gap-3">
          <span
            class="flex items-center justify-center w-12 h-12 rounded-2xl bg-blue-100 dark:bg-blue-900/40 text-2xl shrink-0"
            >📅</span>
          <div class="flex-1 min-w-0">
            <h3 class="text-lg font-extrabold text-n-slate-12 break-words">
              {{ externalEventDetails.title }}
            </h3>
            <div class="flex items-center gap-2 mt-1 flex-wrap">
              <span
                class="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 rounded-full"
                >{{
                  externalEventDetails.origin === 'google'
                    ? 'Google Calendar'
                    : 'Externo'
                }}</span>
              <span
                v-if="externalEventDetails.appointmentId"
                class="text-[10px] text-n-slate-10"
                >ID: {{ externalEventDetails.appointmentId }}</span>
            </div>
          </div>
        </div>

        <div
          class="grid grid-cols-1 gap-3 text-sm border-t border-b border-n-weak py-4"
        >
          <div
            v-if="externalEventDetails.scheduled_at"
            class="flex items-start gap-2"
          >
            <span
              class="i-ri-calendar-schedule-line size-4 text-n-slate-11 mt-0.5 shrink-0"
            />
            <div class="text-n-slate-12 font-medium">
              {{
                new Date(externalEventDetails.scheduled_at).toLocaleString(
                  'pt-BR',
                  {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long',
                    hour: '2-digit',
                    minute: '2-digit',
                  }
                )
              }}
            </div>
          </div>
          <div class="flex items-center gap-2">
            <span class="i-ri-timer-line size-4 text-n-slate-11 shrink-0" />
            <label class="text-n-slate-12 text-xs">Duração:</label>
            <select
              :value="externalEventDetails.duration_min || ''"
              :disabled="externalDurationSaving"
              class="px-2 py-1 text-xs bg-n-solid-2 border border-n-weak rounded-md focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
              @change="
                e =>
                  saveExternalDuration(
                    e.target.value ? Number(e.target.value) : null
                  )
              "
            >
              <option value="">Padrão</option>
              <option :value="15">15 min</option>
              <option :value="30">30 min</option>
              <option :value="45">45 min</option>
              <option :value="60">1h</option>
              <option :value="90">1h30</option>
              <option :value="120">2h</option>
              <option :value="180">3h</option>
            </select>
            <span
              v-if="externalDurationSaving"
              class="text-[10px] text-n-slate-10"
              >salvando...</span>
          </div>
          <div class="flex items-center gap-2">
            <span
              class="i-ri-checkbox-circle-line size-4 text-n-slate-11 shrink-0"
            />
            <label class="text-n-slate-12 text-xs">Status:</label>
            <select
              :value="externalEventDetails.status || 'scheduled'"
              :disabled="externalStatusSaving"
              class="px-2 py-1 text-xs bg-n-solid-2 border border-n-weak rounded-md focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
              @change="e => saveExternalStatus(e.target.value)"
            >
              <option value="scheduled">Agendado</option>
              <option value="attended">Compareceu</option>
              <option value="no_show">Não compareceu</option>
              <option value="cancelled">Cancelado</option>
            </select>
            <span
              v-if="externalStatusSaving"
              class="text-[10px] text-n-slate-10"
              >salvando...</span>
            <span
              v-if="externalEventDetails.status === 'cancelled'"
              class="ml-auto inline-flex items-center px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide rounded-full bg-rose-100 dark:bg-rose-900/40 text-rose-700 dark:text-rose-300"
              >Cancelado</span>
          </div>
          <div
            v-if="externalEventDetails.contact"
            class="flex items-start gap-2"
          >
            <span
              class="i-ri-user-line size-4 text-n-slate-11 mt-0.5 shrink-0"
            />
            <div class="flex-1 min-w-0">
              <div class="text-n-slate-12 font-medium">
                {{ externalEventDetails.contact.name }}
              </div>
              <div
                v-if="
                  externalEventDetails.contact.phone_number ||
                  externalEventDetails.contact.email
                "
                class="text-xs text-n-slate-11"
              >
                <span v-if="externalEventDetails.contact.phone_number">{{
                  externalEventDetails.contact.phone_number
                }}</span>
                <span
                  v-if="
                    externalEventDetails.contact.phone_number &&
                    externalEventDetails.contact.email
                  "
                >
                  -
                </span>
                <span v-if="externalEventDetails.contact.email">{{
                  externalEventDetails.contact.email
                }}</span>
              </div>
            </div>
            <button
              type="button"
              class="text-xs text-rose-600 dark:text-rose-400 hover:underline shrink-0"
              :disabled="externalContactLinking"
              @click="unlinkExternalEventContact"
            >
              Desvincular
            </button>
          </div>
        </div>

        <div v-if="!externalEventDetails.contact" class="space-y-2">
          <div class="flex items-center gap-2">
            <span class="i-ri-link size-3.5 text-n-slate-11" />
            <span class="text-sm font-medium text-n-slate-12">Vincular contato</span>
          </div>
          <input
            v-model="externalContactQuery"
            type="search"
            placeholder="Buscar por nome, email ou telefone..."
            class="w-full px-3 py-2 text-sm bg-n-solid-2 border border-n-weak rounded-xl focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
            @input="searchContactsForExternalEvent(externalContactQuery)"
          />
          <div
            v-if="externalContactSearching"
            class="text-xs text-n-slate-11 px-1"
          >
            Buscando...
          </div>
          <div
            v-else-if="
              externalContactQuery.length >= 2 &&
              externalContactResults.length === 0
            "
            class="text-xs text-n-slate-11 px-1"
          >
            Nenhum contato encontrado.
          </div>
          <div
            v-else-if="externalContactResults.length > 0"
            class="max-h-48 overflow-y-auto rounded-xl border border-n-weak bg-n-solid-1 divide-y divide-n-weak"
          >
            <button
              v-for="ct in externalContactResults"
              :key="ct.id"
              type="button"
              class="w-full text-left px-3 py-2 text-sm hover:bg-n-alpha-2 disabled:opacity-50"
              :disabled="externalContactLinking"
              @click="linkExternalEventToContact(ct)"
            >
              <div class="font-medium text-n-slate-12 truncate">
                {{ ct.name }}
              </div>
              <div class="text-xs text-n-slate-11 truncate">
                <span v-if="ct.phone_number">{{ ct.phone_number }}</span>
                <span v-if="ct.phone_number && ct.email"> - </span>
                <span v-if="ct.email">{{ ct.email }}</span>
              </div>
            </button>
          </div>
        </div>

        <div class="space-y-2">
          <div class="flex items-center justify-between">
            <span class="text-sm font-medium text-n-slate-12">Descrição</span>
            <button
              v-if="!externalDescriptionEditing"
              type="button"
              class="text-xs text-woot-600 dark:text-woot-400 hover:underline"
              @click="startEditExternalDescription"
            >
              Editar
            </button>
          </div>
          <p
            v-if="
              !externalDescriptionEditing &&
              (externalEventDetails.description || externalEventDetails.title)
            "
            class="text-sm text-n-slate-12 whitespace-pre-wrap p-3 bg-n-solid-2/50 rounded-md"
          >
            {{ externalEventDetails.description || externalEventDetails.title }}
          </p>
          <p
            v-else-if="!externalDescriptionEditing"
            class="text-sm italic text-n-slate-10"
          >
            Sem descrição
          </p>
          <div v-if="externalDescriptionEditing" class="space-y-2">
            <textarea
              v-model="externalDescriptionDraft"
              rows="3"
              class="w-full px-3 py-2 text-sm bg-n-solid-2 border border-n-weak rounded-xl focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500 resize-y"
            />
            <div class="flex items-center justify-end gap-2">
              <button
                type="button"
                class="px-3 py-1 text-xs font-medium text-n-slate-11 hover:text-n-slate-12"
                :disabled="externalDescriptionSaving"
                @click="externalDescriptionEditing = false"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="px-3 py-1 text-xs font-medium bg-woot-500 hover:bg-woot-600 text-white rounded-md disabled:opacity-50"
                :disabled="externalDescriptionSaving"
                @click="saveExternalDescription"
              >
                {{ externalDescriptionSaving ? 'Salvando...' : 'Salvar' }}
              </button>
            </div>
          </div>
        </div>

        <div
          class="flex items-center justify-end gap-2 pt-3 border-t border-n-weak"
        >
          <Button
            color="primary"
            size="sm"
            :disabled="!resolvedConversationDisplayId"
            @click="navigateToLeadConversation"
          >
            <template #icon>
              <span class="i-ri-external-link-line size-3.5" />
            </template>
            Ver Conversa
          </Button>
        </div>
      </div>
    </Modal>
  </div>

  <!-- Drag preview tooltip: aparece durante drag-drop em time slot, segue
       o cursor e mostra o horario alvo (ex: 21:30). Snap em 30min baseado
       em qual metade da celula o cursor esta. -->
  <div
    v-if="dragTimeTarget"
    class="fixed z-50 pointer-events-none px-2.5 py-1 rounded-md text-xs font-bold bg-woot-500 text-white shadow-lg tabular-nums"
    :style="{
      left: dragTimeTarget.x + 14 + 'px',
      top: dragTimeTarget.y + 14 + 'px',
    }"
  >
    {{ String(dragTimeTarget.hour).padStart(2, '0') }}:{{
      String(dragTimeTarget.minute).padStart(2, '0')
    }}
  </div>
</template>

<style lang="scss" scoped>
.calendar-container {
  @apply bg-n-solid-1 h-full flex flex-col;
  position: relative;
  isolation: isolate;
}

.mini-calendar-section {
  @apply relative flex flex-col;
  background-color: inherit;
  height: 100%;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  > div {
    display: flex;
    flex-direction: column;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.mini-calendar {
  .grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  flex-shrink: 0;
}

.calendar-grid {
  @apply grid;
  flex: 1;
  min-height: 0;
  border-left: 1px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
  position: relative;
  isolation: isolate;
  height: calc(100% - 48px);
  overflow-y: auto;

  &[data-view-mode='week'] {
    display: block;
    height: 100%;

    > div {
      display: grid;
      grid-template-columns: 4rem repeat(7, minmax(0, 1fr));
      width: 100%;
      min-height: 1920px; /* 24 hours * 80px */
    }
  }

  &[data-view-mode='month'] {
    grid-template-rows: repeat(6, 1fr);
    height: 100%;
  }
}

.calendar-header {
  @apply sticky top-0;
  background-color: inherit;
}

.week-day-header {
  position: relative;

  &:not(:last-child)::after {
    content: '';
    @apply absolute right-0 top-1/2 -translate-y-1/2 h-4 w-px bg-n-alpha-2;
  }
}

.calendar-day {
  @apply p-2 relative;
  height: 100%;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  isolation: isolate;

  .dark & {
    border-right-color: #334155;
    border-bottom-color: #334155;
    border-top-color: #334155;
  }

  &:hover {
    /* hover styles */
  }

  > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .day-events-container {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  // Improve spacing for better layout (sem borda lateral nos chips da agenda)
  .event-item {
    min-height: 24px;
    display: flex;
    align-items: center;
    border: none !important;
    border-left: none !important;
    border-left-width: 0 !important;
  }

  &[data-view-mode='week'] {
    height: 100%;
    min-height: 100%;
    overflow: hidden;
    border: none; // Remove border from calendar day cells
  }
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--color-border);
  border-top: 3px solid var(--color-woot);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

// Estilizar a scrollbar horizontal
.overflow-x-auto {
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 transparent;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #94a3b8;
    border-radius: 3px;
  }
}

.dark .overflow-x-auto {
  scrollbar-color: #475569 transparent;

  &::-webkit-scrollbar-thumb {
    background-color: #475569;
  }
}

// Adicionar estilos para a transição
.overflow-hidden {
  overflow: hidden;
}

// Ajustar scrollbar para ser mais sutil
.overflow-x-auto {
  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    @apply bg-n-alpha-2;
    border-radius: 2px;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      @apply bg-n-slate-9 bg-n-slate-8;
    }
  }
}

// Eventos de hoje
.today-events-section {
  @apply relative;
  padding: 0;
}

.events-list {
  flex: 1;
  min-height: 0;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

// Consolidated with main calendar-grid styles

// Removido: estilos para time slots

.calendar-day {
  &[data-view-mode='week'] {
    height: 100%;
    min-height: 100%;
    border: none;
    position: relative;
    padding: 0;
    flex: 1;
    min-width: 0;
  }
}
</style>
